<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <Header />

    <!--Primer nivel (Seleccion de vista)-->
    <b-card class="bCardAgenda" >
      <b-row>
        <b-col>
          <b-button-group style="border-radius: 60px; background-color:  var(--color-background-disabled); height: 20px; width: 300px">
            <b-button :class="!semanalDiaria ? 'boton-agenda-switch-active' : 'boton-agenda-switch'" :pressed="!semanalDiaria"
                      @click="cambiarVistaSemanal()">Semanal</b-button>
            <b-button :class="semanalDiaria ? 'boton-agenda-switch-active' : 'boton-agenda-switch'"  :pressed="semanalDiaria"
                      @click="cambiarVistaDiaria()">Diaria</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row class="mt-1 ml-1 mr-1">
        <b-col style="text-align: left;" >
          <div style="display: flex">
            <label for="clinicaSelect" style="display: inline; margin: auto;">Clínica:</label>
            <v-select
                style="
                          width: 70%;
                          border: 2px solid;
                          border-color: #aceaf4;
                          border-radius: 8px;
                          display: inline;
                        "
                :clearable="false"
                :options="listaClinicasFiltro.length > 0 ? listaClinicasFiltro : listaClinicas"
                v-model="datosBusqueda.clinica.clinicaID"
                :reduce="(variable) => variable.id"
                label="nombre"
                placeholder="Selecciona una clínica"
                :filterable="false"
                @search="filtroClinicas"

                @input="actualizarNombreClinica(false)"
            >
                        <span slot="no-options"
                        >No hay clinicas disponibles</span
                        >
            </v-select>
          </div>
        </b-col>
        <b-col style="text-align: center;margin: auto;">
          <b-button class="boton-agenda" variant="primary" @click="mostrarModalCrearCitaV2();"
              v-if="clinicaEstaSeleccionada && $localStorageService.can('bt_agendar_cc')"
                    title="Crear cita">
            <em class="calendar_svg icon-boton-agenda"></em>
          </b-button>

          <b-button class="boton-agenda" variant="outline-primary" @click="mostrarModalCrearCita(true, false)"
                    title="Crear cita embajador"
              v-if="clinicaEstaSeleccionada && $localStorageService.can('CA_06_crear_cita_embajador')">
            <em class="cita_svg icon-boton-agenda"></em>
          </b-button>

          <b-button id="popover-lista-espera" class="boton-agenda" variant="primary" ref="botonlistaespera">
            <em class="lista_espera_svg icon-boton-agenda"></em>
          </b-button>

          <b-popover v-if="!showDialogEnviaListEspera && !showDialogModalBandejaEspera" target="popover-lista-espera" triggers="click blur" placement="bottom" style="max-width: 200px">

              <div style="width: 160px;text-align: left;">
            <b-button v-if="!showDialogEnviaListEspera" style="padding: 0px;" class="filtros" @click="activarModalEspera()" >
              Agregar a lista de espera
            </b-button>
            <b-button v-if="!showDialogModalBandejaEspera" style="padding: 0px;" class="filtros" @click="mostrarBandejaEspera()">
              Bandeja de lista de espera
            </b-button>
              </div>
          </b-popover>

        </b-col>
        <b-col style="text-align: right;margin: auto;">

            <b-button class="boton-agenda-inv" style="margin-left: 5%;" variant="primary" @click="activarBarraLateral()" v-if="semanalDiaria">
              <em class="agenda_svg icon-boton-agenda-1"></em>
            </b-button>

            <b-button class="boton-agenda-inv" style="margin-left: 5%;" variant="primary" @click="buscarAgenda()">
              <em class="refresh_svg icon-boton-agenda-1"></em>
            </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!--Segundo nivel (Filtros)-->
    <b-card class="bCardAgenda">
      <b-row class="mt1 ml-1 mr-1">
        <b-col style="text-align: right">
          <b-button id="filtros-title" disabled>
            <em class="filtros_svg icon-boton-agenda-1"></em>
          </b-button>

          <!--  Estado del Paciente -->

          <b-button id="popover-filtro-tipopaciente" class="filtros" :class="filtros.selects.tipos.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.tipos.length>0"> &nbsp;({{filtros.selects.tipos.length}})</span>
            <span>
              Estado del Paciente
            </span>
            &nbsp;<em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-tipopaciente" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.tipos"  style="width: 180px; overflow: auto; max-height: 200px">
              <b-form-checkbox v-for="op in filtros.options.tipos" :key="op.titulo"
                               :value="op.id">
                <span
                    class="color"
                    :style="`box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.16); border-radius: 60px;background-color: ${op.color}`"
                ></span>
                {{op.titulo}}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>

          <!--  Estatus de la cita -->

          <b-button id="popover-filtro-estatus" class="filtros" :class="filtros.selects.estatusCita.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.estatusCita.length>0"> &nbsp;({{filtros.selects.estatusCita.length}})</span>
            <span >
              Estatus de la cita
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-estatus" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.estatusCita"  style="width: 200px;">
              <b-form-checkbox v-for="op in filtros.options.estatusCita"
                               :key="op.titulo"
                               :value="op.id">
                <span
                    class="color"
                    :style="`box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.16); border-radius: 60px;${op.color};`"
                ></span>
                {{op.titulo}}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>
          <b-button id="popover-filtro-motivos" class="filtros" :class="filtros.selects.motivosCita.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.motivosCita.length>0"> &nbsp;({{filtros.selects.motivosCita.length}})</span>
            <span >
              Motivo de la cita
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-motivos" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.motivosCita"  style="width: 200px;">
              <b-form-checkbox v-for="op in filtros.options.motivosCita"
                               :key="op.titulo"
                               :value="op.id">
                <table>
                  <tr>
                    <th >
                      {{op.titulo}}
                    </th>
                  </tr>
                </table>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>
          <!-- Canal de la cita -->
          <b-button id="popover-filtro-canalCita" class="filtros" :class="filtros.selects.canalCita.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.canalCita.length>0"> &nbsp;({{filtros.selects.canalCita.length}})</span>
            <span>
              Canal de la Cita
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-canalCita" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.canalCita" style="width: 250px;overflow: auto;max-height: 200px">
              <b-form-checkbox v-for="op in filtros.options.canalCita"
                               :key="op.titulo"
                               :value="op.id">
                <table>
                  <tr>
                    <th >
                      {{op.titulo}}
                    </th>
                  </tr>
                </table>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>
       
          <b-button id="popover-filtro-especialidad" class="filtros" :class="filtros.selects.especialidades.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.especialidades.length>0"> &nbsp;({{filtros.selects.especialidades.length}})</span>
            <span>
              Especialidad
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-especialidad" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.especialidades" style="width: 250px;overflow: auto;max-height: 200px">
              <b-form-checkbox v-for="op in filtros.options.especialidades" :key="op.titulo"
                               :value="op.id">
                <table>
                  <tr>
                  <th style="width: 30px">
                    <span style="position: absolute; top: 4px;"
                        class="color"
                        :style="`box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.16); border-radius: 60px; background:${op.color};`"
                    ></span>
                  </th>
                  <th >
                    {{op.titulo}}
                  </th>
                  </tr>
                </table>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>

          <!-- Plan -->

          <b-button id="popover-filtro-plan" class="filtros" :class="filtros.selects.planes.length > 0 || filtros.selects.pacienteNatural || filtros.selects.pacientePlan?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.planes.length > 0 || filtros.selects.pacienteNatural || filtros.selects.pacientePlan">
                  ({{(filtros.selects.planes === null ? 0 : filtros.selects.planes.length) +
            (filtros.selects.pacienteNatural ? Number(1):Number(0)) +
            (filtros.selects.pacientePlan ? Number(1):Number(0))
              }})</span>
            <span>
              Plan
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-plan" triggers="click blur" placement="bottom">

            <div>
              <b-form-checkbox v-model="filtros.selects.pacienteNatural" :checked="filtros.selects.pacienteNatural">
                <span style="font-size: 10px !important;color: gray;" >Natural</span>
              </b-form-checkbox>
              <b-form-checkbox v-model="filtros.selects.pacientePlan" :checked="filtros.selects.pacientePlan" @change="limpiarSeleccionPlan()" >
                <span style="font-size: 10px !important;color: gray;" >Plan</span>
              </b-form-checkbox>
            </div>
            <div v-if="filtros.selects.pacientePlan">

              <b-dropdown-divider></b-dropdown-divider>

              <div style="display:flex;font-size: 10px !important;color: gray;">
                <b-form-checkbox :checked="filtros.selects.todosPlanes" @change="seleccionarTodosLosPlanes" >
                  <span style="font-size: 10px !important;color: gray;" >Seleccionar todo</span>
                </b-form-checkbox>
                <span  style="font-size: 10px !important;color: gray; cursor:pointer;  margin-left: auto;"
                       v-if="filtros.selects.planes.length > 0"
                       @click="limpiarSeleccionPlan()">
                  <em class="fa fa-close"> Limpiar </em>
                </span>
              </div>

              <b-form-checkbox-group v-model="filtros.selects.planes"  style="width: 250px;">
                <b-form-checkbox v-for="op in filtros.options.planes" :key="op.titulo" @change="seleccionarPlan"
                                 :value="op.id">

                  <table>
                    <tr>
                      <th style="width: 30px">
                        <img alt="img" v-if="op.img !== undefined && op.img !== null && op.img !== ''" style="width: 15px;position: absolute; top: 4px;" :src="'data:image/png;base64,'+op.img">
                      </th>
                      <th >
                        {{op.titulo}}
                      </th>
                    </tr>
                  </table>

                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </b-popover>

          <!-- Doctor -->

          <b-button id="popover-filtro-doctor" class="filtros" :class="filtros.selects.doctores.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.doctores.length>0"> &nbsp;({{filtros.selects.doctores.length}})</span>
            <span>
              Doctor
            </span>
            <em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-doctor" triggers="click blur" placement="bottom">

            <b-form-input
                v-model="filtros.selects.nombreDoctor"
                placeholder="Ingresa un nombre"
                type="text"
                v-on:keypress="esLetra($event)"
                @keyup.prevent="buscarDoctoresEnFiltros()"
            ></b-form-input>

            <b-dropdown-divider></b-dropdown-divider>

            <b-form-checkbox-group stacked v-model="filtros.selects.doctores" style="overflow: auto; max-height: 200px">
              <template v-for="op in filtros.options.doctores">
                <b-form-checkbox  :key="op.titulo"
                                 :value="op.id"  v-if="op.visible">
                {{op.titulo}}
                </b-form-checkbox>
              </template>
            </b-form-checkbox-group>
          </b-popover>

          <!-- Sillón -->

          <b-button id="popover-filtro-sillon" class="filtros" :class="filtros.selects.sillones.length>0?'':'filtro-normal'" @click="llenarFiltros()">
            <span v-if="filtros.selects.sillones.length>0"> &nbsp;({{filtros.selects.sillones.length}})</span>
            <span>
              Sillón
            </span>
            &nbsp;<em class="arrow_down_svg icon-boton-agenda-2"></em>
          </b-button>
          <b-popover target="popover-filtro-sillon" triggers="click blur" placement="bottom">
            <b-form-checkbox-group stacked v-model="filtros.selects.sillones" style="width: 120px; max-height: 200px; overflow: auto;">
              <b-form-checkbox v-for="op in filtros.options.sillones" :key="op.titulo"
                               :value="op.id">
                <span>{{op.titulo}}</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-popover>

          <b-button class="boton-agenda-inv" style="margin-left: 1%" variant="primary"
                    v-if="tieneFiltros()"
                    @click="borrarFiltros()">
            <em class="close_x_svg icon-boton-agenda-11"></em>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!--Tercer nivel (Selector de fecha)-->
    <b-card class="bCardAgenda">
      <b-row class="mt-2 ml-3 mr-3">
        <b-col>
            <div class="selectWeek">
              <button
                  :class="$moment(datosBusqueda.fechaActual).format('DD/MM/YY') === $moment().format('DD/MM/YY') ? 'fecha-dia-actual' : 'selectWeek'"
                  aria-label="Previous week"
                  class="vuecal__arrow vuecal__arrow--prev"
                  v-on:click="cambiarAnteriorSemana()"
              >
                &nbsp;<i class="angle"></i>&nbsp;
              </button>

              <b-button id="popover-calendario">
                <span :class="$moment(datosBusqueda.fechaActual).format('DD/MM/YY') === $moment().format('DD/MM/YY') ? 'fecha-dia-actual' : 'selectWeek'">
                  {{semana.numeroSemana}} / {{  $moment(datosBusqueda.fechaActual).format('dddd') }}, {{  $moment(datosBusqueda.fechaActual).format('LL') }}
                </span>
              </b-button>
              <b-popover target="popover-calendario" triggers="click blur" placement="bottom">
                <b-calendar style="width: 90%;" v-model="datosBusqueda.fechaActual" class="mb-2"  locale="es-MX" :valueAsDate="true"  @input="seleccionarFechaCalendario" ></b-calendar>
              </b-popover>


              <button
                  :class="$moment(datosBusqueda.fechaActual).format('DD/MM/YY') === $moment().format('DD/MM/YY') ? 'fecha-dia-actual' : 'selectWeek'"
                  aria-label="Next week"
                  class="vuecal__arrow vuecal__arrow--next"
                  v-on:click="cambiarSiguienteSemana()"
              >
                &nbsp;<i class="angle"></i>&nbsp;
              </button>

            </div>
        </b-col>
      </b-row>
    </b-card>

    <b-row class="mr-0">

     <b-col>
        <!--Agenda Diaria-->

         <b-row v-if="!loadingCAl && semanalDiaria">
           <b-col :cols="mostrarBarraLateral ? 10 : 12" style="padding: 0;">
             <b-card class="bCardAgenda">
               <calendario-dia
                   @mostrarDetalle="mostrarDetalle"
                   @seleccionarFecha="seleccionarFechaPorDiaSemana"
                   @crearCitaDesdeCalendario="mostrarModalCrearCitaDesdeCalendarioV2"
                   :listaMotivosHerramientas="listaMotivosHerramientas"
                   :listaMotivosCancelacion="listaMotivosCancelacion"
                   :listaKitsPacienteNuevo="listaKitsPacienteNuevo"
                   :idEspecialidadFiltro="idEspecialidadFiltro"
                   :loading="loading"
                   :filtros="filtros"
                   ref="calDentaliaDiario">
               </calendario-dia>
             </b-card>
           </b-col>

           <transition name="slide-fade">
               <b-col v-if="mostrarBarraLateral" cols="2" style="padding: 0;">
                    <b-card class="bCardAgenda bCardAgenda-lateral">
                   <div style="height: 90%;">

                     <div class="mb-3"></div>

                     <div style="display: inline; padding: 5px; cursor:pointer;" @click="mostrarBarraLateral = !mostrarBarraLateral">
                       <span>Citas en las prox 3 horas</span>
                       <em style="float: right; height: 20px; transition: transform 1s;" class="right_chevron_svg icon-boton-agenda-2"></em>
                     </div>

                     <div class="mb-3"></div>

                     <transition name="slide-fade">
                       <div style="display: flex; height: 100%" v-if="mostrarBarraLateralCitas && obtenerProximasCitas.length===0">
                         <div class="caja-barra-lateral" ref="refbarralateral" style="margin: auto">
                           <div style="text-align: center;">No hay citas proximas</div>
                         </div>
                       </div>

                       <div class="caja-barra-lateral" ref="refbarralateral" v-if="mostrarBarraLateralCitas && obtenerProximasCitas.length>0">
                         <div class="caja-barra-lateral-body">
                           <template v-for="c in obtenerProximasCitas" >
                              <b-card class="bCardAgenda" :key="c.idCita" @contextmenu.prevent="activarMenuDesdeProxCita($event, c);">
                               <div class="mb-1">
                                 <em class="clock_outline_svg icon-boton-agenda-3"></em>
                                 {{c.horaInicioCasilla}} - {{c.horaFinCasilla}}
                                 <span style="float: right; color:  rgb(147, 147, 147);">
                                   {{ c.fechaInicioCompletaHoraMin.diff($moment(), 'minutes') }} min
                                 </span>
                               </div>
                               <div class="mb-1">
                                 <em class="teeth_outline_svg icon-boton-agenda-3"></em>
                                 <span  v-for="tratamiento in c.tratamientos"
                                        v-bind:key="tratamiento.idTratamiento">
                                    {{ tratamiento.nombreTratamiento }}
                                 </span>
                               </div>
                               <div class="mb-1">
                                 <em class="dentist_svg icon-boton-agenda-3"></em>
                                 {{ c.nombrePaciente }}
                               </div>
                               <div class="mb-1">
                                 <em class="sillon_svg icon-boton-agenda-3"></em>
                                 Sillón {{ c.sillon }}
                               </div>
                             </b-card>
                           </template>
                         </div>
                       </div>
                     </transition>
                   </div>
                 </b-card>
               </b-col>
           </transition>

         </b-row>

        <!--Agenda Semanal-->
        <b-card class="bCardAgenda" v-else>
            <b-row>
              <b-col v-if="!loadingCAl">
                <calendario-semanal
                    @mostrarDetalle="mostrarDetalle"
                    @seleccionarFecha="seleccionarFechaPorDiaSemana"
                    @crearCitaDesdeCalendario="mostrarModalCrearCitaDesdeCalendarioV2"
                    :listaMotivosHerramientas="listaMotivosHerramientas"
                    :listaMotivosCancelacion="listaMotivosCancelacion"
                    :listaKitsPacienteNuevo="listaKitsPacienteNuevo"
                    :idEspecialidadFiltro="idEspecialidadFiltro"
                    :filtros.sync="filtros"
                    ref="calDentaliaSemanal"
                >
                </calendario-semanal>
              </b-col>
              <b-spinner v-if="loadingCAl"/>
            </b-row>
        </b-card>

      </b-col>
    </b-row>

    <b-modal
        size="lg"
        v-model="busquedaOverbooking"
        id="modalOverbooking"
        title="Buscar overbooking"
    >
      <div>
        <p>La búsqueda del overbooking toma en cuenta el doctor, especialidad, el horario de citas que ya están
          registradas en el calendario y el índice de confianza del paciente actual.</p>
        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Paciente:
                <validacion/>
              </b-col>
              <b-col cols="6" align="right"></b-col>
            </b-row>
          </label>
          <b-form-group id="paciente-fg-agr-cita">
            <b-input-group id="paciente-ig-agr-cita">
              <template v-slot:append>
                <b-button
                    v-if="mostrarBusquedaPaciente"
                    variant="outline-primary"
                    @click="llenarPacientesClinica()"
                >
                  <b-icon class="searchicon" icon="search"></b-icon>
                </b-button>
                <b-button
                    v-if="!mostrarBusquedaPaciente"
                    variant="outline-warning"
                    :disabled="secondReagendar"
                    @click="limpiarPacienteSeleccionado"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </template>
              <b-form-input

                  v-if="
                    mostrarBusquedaPaciente &&
                    (tipoBusqueda === undefined ||
                      tipoBusqueda === null ||
                      tipoBusqueda === 1)
                  "
                  v-model="datosFormulario.nombrePacienteBusqueda"
                  placeholder="Ingresa un nombre"
                  type="text"
                  v-on:keypress="esLetra($event)"
                  v-b-tooltip.hover
                  title="Búsqueda básica por nombre completo del paciente"
                  @keydown.enter.prevent="llenarPacientesClinica()"
              ></b-form-input>
              <b-form-input
                  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2"

                  v-model="datosFormulario.nombrePacienteBusqueda"
                  placeholder="Ingresa un nombre"
                  type="text"
                  v-b-tooltip.hover
                  title="Búsqueda avanzada (Nombre Paterno Materno DD-MM-YYYY). Ejem: (fern * * 1900-01-31). El comodin * funciona para los apellidos"
                  @keydown.enter.prevent="llenarPacientesClinica()"
              ></b-form-input>
              <b-form-input
                  v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
                  v-model="datosFormulario.nombrePacienteBusqueda"
                  :min="0"
                  placeholder="Ingresa un ID de PX"
                  type="number"
                  v-b-tooltip.hover
                  title="Id del paciente"
                  @keydown.enter.prevent="llenarPacientesClinica()"
              ></b-form-input>
              <b-form-input
                  v-if="!mostrarBusquedaPaciente"
                  disabled
                  required
                  v-model="datosFormulario.nombrePaciente"
                  placeholder="Selecciona un paciente de los resultados"
                  type="text"
                  v-on:keypress="esLetra($event)"
              ></b-form-input>
            </b-input-group>

            <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
              <div class="centrar">
                <b-form-radio-group
                    v-if="overbookListaEspera == false"
                    id="btn-tipos_busqueda_paciente"
                    v-model="tipoBusqueda"
                    :options="[
                      { text: 'Búsq. normal', value: 1 },
                      { text: 'Búsq. avanzada', value: 2 },
                      { text: 'Búsq. ID', value: 3 },
                    ]"
                    :aria-describedby="ariaDescribedbyTipoBusqueda"
                    button-variant="outline-primary"
                    size="sm"
                    name="radio-btn-outline"
                ></b-form-radio-group>
              </div>
            </b-form-group>

            <b-container class="bv-example-row">
              <b-row>
                <div class="centrar">
                  <b-col cols="10">
                    <b-spinner small v-if="loadingPacientes"/>
                    <span
                        class="tablePatients"
                        v-if="
                          !loadingPacientes &&
                          mostrarBusquedaPaciente &&
                          listaPacientes.length > 0
                        "
                        column="3"
                    >
                        <div class="mt-2 col-md-12"></div>
                        <b-table
                            v-if="!overbookListaEspera"
                            thead-tr-class="columnas"
                            :items="listaPacientes"
                            :fields="encabezados"
                            :per-page="registrosPorPagina"
                            :current-page="paginaActual"
                            :hover="true"
                            :small="true"
                            @row-clicked="setearPaciente"
                            class="parrafos"
                            responsive
                            fixed
                        >
                          <template v-slot:cell(id)="row">
                            <span>{{ row.item.id }}</span>
                          </template>
                          <template v-slot:cell(name)="row">
                            <div class="spanCien">
                              <span>
                                {{
                                  row.item.esPacienteNuevo ? "*" : ""
                                }}{{ row.item.name }}
                              </span>
                            </div>
                          </template>
                          <template v-slot:cell(saldo)="row">
                            {{ row.item.saldo }}
                          </template>
                          <template v-slot:cell(plan)="row">
                            <span>
                              {{ plan.nombre }}
                            </span>
                          </template>
                        </b-table>
                        <b-pagination
                            v-if="listaPacientes.length > 15"
                            align="center"
                            v-model="paginaActual"
                            :total-rows="listaPacientes.length"
                            :per-page="registrosPorPagina"
                        ></b-pagination>
                      </span>
                  </b-col>
                </div>
              </b-row>
            </b-container>
          </b-form-group>
        </div>


        <b-row>
          <b-col>
            <div v-if="datosFormulario.citaEmbajador">
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                  v-if="datosFormulario.citaEmbajador"
              >
                <label>Embajador </label>
                <validacion/>
                <b-spinner
                    small
                    v-if="
                      loadingDoctoresClinica ||
                      loadingDoctores ||
                      loadingDoctoresEsp
                    "
                />
                <b-form-group v-else>
                  <v-select
                      :options="listaDoctores"
                      v-model="datosFormulario.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un embajador (*)"
                      :disabled="secondReagendar || secondCitaDesdeCalendario"
                      @input="llenarEspecialidadesDoctor(true)"
                  >
                      <span slot="no-options"
                      >No hay embajadores disponibles</span
                      >
                  </v-select>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </div>
            <div v-else>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Doctor</label>
                <validacion/>
                <b-form-group>
                  <v-select
                      :options="listaDoctoresFiltro"
                      :filterable="false"
                      @search="filtroDoctores"
                      v-model="datosFormulario.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un doctor (*)"
                      :disabled="secondReagendar || secondCitaDesdeCalendario || overbookListaEspera"
                      @input="llenarEspecialidadesDoctor(true)"
                  >
                    <span slot="no-options">No hay doctores disponibles</span>
                  </v-select>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <validation-provider :rules="{ required: true }" v-slot="errors">
              <label>Fecha</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingHorariosClinica"/>
                <b-form-datepicker
                    id="fechacita-datepicker"
                    labelNoDateSelected="Fecha"
                    range
                    v-else
                    v-model="datosFormulario.fechaCita"
                    class="mb-2"
                    no-flip
                    in
                    :disabled="citaIsOverbooking"
                ></b-form-datepicker>
                <!-- :min="fechaMinima" -->

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
            <p style="font-size: 11px">Nota: La búsqueda se realizará en un rango de fechas, a partir del día
              seleccionado y agregando 7 días posteriores a la fecha seleccionada</p>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!datosFormulario.citaEmbajador"
            >
              <label>Especialidad</label>
              <validacion/>
              <b-spinner small v-if="loadingEspecialidadesDoc"/>
              <b-form-group v-else>
                <v-select
                    id="idEspecialidad"
                    style="width: 100%"
                    :options="listaEspecialidadesDoctorFiltro"
                    :filterable="false"
                    @search="filtroEspecialidadesDoctor"
                    v-model="datosFormulario.idEspecialidad"
                    :reduce="(variable) => variable.id"
                    label="nombre"
                    placeholder="Selecciona una especialidad"
                    :disabled="secondReagendar || secondCitaDesdeCalendario"
                >
                    <span slot="no-options"
                    >No hay especialidades disponible</span
                    >
                </v-select>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-between">
          <b-button
              :disabled="
              datosFormulario.idPaciente == null &&
              datosFormulario.idDoctor == null &&
              datosFormulario.idEspecialidad == null
            "
              style="background-color: #17A2B8; border-color: #17A2B8; border-style: solid"
              @click="verificarOverbooking()"
          >Buscar overbooking
          </b-button
          >
        </div>
        <div class="mt-4" v-if="buscarOverbooking">
          <div
              style="border-style: solid; border-color: #1dbdd5; border-radius: 20px; border-width: 2px; padding: 2%;"
              v-if="horarioDisponibleOverbooking.length > 0">
            <b-table
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :items="horarioDisponibleOverbooking"
                :fields="fieldsCitas"
            >
              <template #cell(agendar)="row">
                <b-button
                    size="sm"
                    @click="agendarOverbooking(row.item)"
                    class="mr-1"
                    variant="outline-primary"
                >
                  Agendar
                </b-button>
              </template>
            </b-table>
          </div>

          <b-pagination
              class="mt-4"
              v-if="horarioDisponibleOverbooking.length > 0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="overbooking"
              align="center"
          ></b-pagination>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
            variant="outline-secondary"
            @click="
              cerrarOverbooking()
            "
            style="margin-left: 10px"
        >Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal
        size="lg"
        v-model="second"
        :title="
            (secondReagendar ? 'Reagendar Cita' : 'Asignar Cita') +
            (datosFormulario.citaEmbajador ? ' Embajador' : '')
          "
        scrollable
        v-if="clinicaEstaSeleccionada"
        no-close-on-backdrop
    >
      <div class="modalPadding">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(saveEvent)">
            <div>
              <label style="width: 100%">
                <b-row style="width: 100%">
                  <b-col cols="6">Paciente:
                    <validacion/>
                  </b-col>
                  <b-col cols="6" align="right"></b-col>
                </b-row>
              </label>
              <b-form-group id="paciente-fg-agr-cita">
                <b-input-group id="paciente-ig-agr-cita">
                  <template v-slot:append>
                    <b-button
                        v-if="mostrarBusquedaPaciente && tipoBusqueda !== 2"
                        variant="outline-primary"
                        @click="llenarPacientesClinica()"
                    >
                      <b-icon class="searchicon" icon="search"></b-icon>
                    </b-button>
                    <b-button
                        v-if="!mostrarBusquedaPaciente "
                        variant="outline-warning"
                        :disabled="secondReagendar || citaIsOverbooking"
                        @click="limpiarPacienteSeleccionado"
                    >
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                  </template>
                  <b-form-input
                      v-if="
                          mostrarBusquedaPaciente &&
                          (tipoBusqueda === undefined ||
                            tipoBusqueda === null ||
                            tipoBusqueda === 1)
                        "
                      v-model="datosFormulario.nombrePacienteBusqueda"
                      placeholder="Ingresa un nombre "
                      type="text"
                      v-on:keypress="esLetra($event)"
                      v-b-tooltip.hover
                      title="Búsqueda básica por nombre completo del paciente"
                      @keydown.enter.prevent="llenarPacientesClinica()"
                  ></b-form-input>

<!--                      Busqueda avanzada                               -->
                  <div  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2">
                      <br>
                      <b-row>
                        <b-col cols="col-sm-12 col-md-3 col-lg-3">
                          <b-form-input
                              style="width: 100%"
                              v-model="nombre"
                              placeholder=" nombre"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Búsqueda básica por nombre del paciente"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="col-sm-12 col-md-3 col-lg-3">
                          <b-form-input
                              style="width: 100%"
                              v-model="apellidoPaterno"
                              placeholder="apellido paterno"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Apellido Paterno"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="col-sm-12 col-md-3 col-lg-3">
                          <b-form-input
                              style="width: 100%"
                              v-model="apellidoMaterno"
                              placeholder="apellido materno"
                              type="text"
                              v-on:keypress="esLetra($event)"
                              v-b-tooltip.hover
                              title="Apellido Materno"
                              v-on:keyup.enter="getPatientsV2()"
                              class="input-buscador"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="col-sm-12 col-md-1 col-lg-1">
                          <b-button size="sm"
                                    v-if="datosCita == null"
                                    variant="info"
                                    style="margin: auto;"
                                    @click="getPatientsV2()">
                            <span ><em class="buscar_svg" style="height: 16px;"></em></span>
                          </b-button>
                        </b-col>
                      </b-row>
                  </div>

                  <b-form-input
                      v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
                      v-model="datosFormulario.nombrePacienteBusqueda"
                      :min="0"
                      placeholder="Ingresa un ID de PX"
                      type="number"
                      v-b-tooltip.hover
                      title="Id del paciente"
                      @keydown.enter.prevent="llenarPacientesClinica()"
                  ></b-form-input>
                  <b-form-input
                      v-if="!mostrarBusquedaPaciente"
                      disabled
                      required
                      v-model="datosFormulario.nombrePaciente"
                      placeholder="Selecciona un paciente de los resultados"
                      type="text"
                      v-on:keypress="esLetra($event)"
                  ></b-form-input>
                </b-input-group>

                <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
                  <div class="centrar">
                    <b-form-radio-group
                        id="btn-tipos_busqueda_paciente"
                        v-model="tipoBusqueda"
                        :options="[
                            { text: 'Busq. Normal', value: 1 },
                            { text: 'Busq. Avanzada', value: 2 },
                            { text: 'Busq. ID', value: 3 },
                          ]"
                        :aria-describedby="ariaDescribedbyTipoBusqueda"
                        button-variant="outline-primary"
                        size="sm"
                        name="radio-btn-outline"
                    ></b-form-radio-group>
                  </div>
                </b-form-group>
                <div v-if="datosFormulario.indicadorProbabilidad"
                     class="pt-3 d-flex justify-content-between contenedorTablaSinColor">

                  <div class="pl-5">
                    <p style="font-weight: 600; font-size: 14px">Porcentaje de confianza: </p>
                  </div>
                  <div class="pr-5" style="font-size: 14px"><p>{{ datosFormulario.indicadorProbabilidad * 10 }}%</p>
                  </div>

                </div>

                <b-container class="bv-example-row">
                  <b-row>
                    <div class="centrar">
                      <b-col cols="10">
                        <b-spinner small v-if="loadingPacientes"/>
                        <span
                            class="tablePatients"
                            v-if="
                                !loadingPacientes &&
                                mostrarBusquedaPaciente &&
                                listaPacientes.length > 0
                              "
                            column="3"
                        >
                              <div class="mt-2 col-md-12"></div>
                              <b-table
                                  thead-tr-class="columnas"
                                  :items="listaPacientes"
                                  :fields="encabezados"
                                  :per-page="registrosPorPagina"
                                  :current-page="paginaActual"
                                  :hover="true"
                                  :small="true"
                                  @row-clicked="setearPaciente"
                                  class="parrafos"
                                  responsive
                                  fixed
                              >
                                <template v-slot:cell(id)="row">
                                  <span>{{ row.item.id }}</span>
                                </template>
                                <template v-slot:cell(name)="row">
                                  <div class="spanCien">
                                    <span>
                                      {{
                                        row.item.esPacienteNuevo ? "*" : ""
                                      }}{{ row.item.name }}
                                    </span>
                                  </div>
                                </template>
                                <template v-slot:cell(saldo)="row">
                                  {{ row.item.saldo }}
                                </template>
                                <template v-slot:cell(plan)="row">
                                  <span>
                                    {{ plan.nombre }}
                                  </span>
                                </template>
                              </b-table>
                              <b-pagination
                                  v-if="listaPacientes.length > 15"
                                  align="center"
                                  v-model="paginaActual"
                                  :total-rows="listaPacientes.length"
                                  :per-page="registrosPorPagina"
                              ></b-pagination>
                            </span>
                      </b-col>
                    </div>
                  </b-row>
                </b-container>
              </b-form-group>
            </div>

            <b-row>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                    v-if="!secondReagendar"
                >
                  <label>Motivo Cita</label>
                  <validacion/>
                  <v-select
                      :options="tagmotivocitaDatosArrayFiltro"
                      :filterable="false"
                      @search="filtrotagmotivocitaDatos"
                      v-model="datosFormulario.idTagMotivoCita"
                      :reduce="(variable) => variable.idTagMotivoCita"
                      label="descripcionTagMotivoCita"
                      placeholder="Selecciona un motivo de cíta"
                      @input="setearMotivoTag($event)"
                  >
                        <span slot="no-options"
                        >No hay motivos de cíta disponibles</span
                        >
                  </v-select>
                </validation-provider>
              </b-col>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <label>Fecha</label>
                  <validacion/>
                  <b-form-group>
                    <b-spinner small v-if="loadingHorariosClinica"/>
                    <b-form-datepicker
                        id="fechacita-datepicker"
                        labelNoDateSelected="Fecha"
                        range
                        v-else
                        v-model="datosFormulario.fechaCita"
                        class="mb-2"
                        :min="fechaMinima"
                        in
                        no-flip
                        :disabled="citaIsOverbooking"
                    ></b-form-datepicker>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <div v-if="datosFormulario.citaEmbajador">
                  <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                      v-if="datosFormulario.citaEmbajador"
                  >
                    <label>Embajador </label>
                    <validacion/>
                    <b-spinner
                        small
                        v-if="
                            loadingDoctoresClinica ||
                            loadingDoctores ||
                            loadingDoctoresEsp
                          "
                    />
                    <b-form-group v-else>
                      <v-select
                          :options="listaDoctoresFiltro"
                          :filterable="false"
                          @search="filtroDoctores"
                          v-model="datosFormulario.idDoctor"
                          :reduce="(variable) => variable.id"
                          label="nombre"
                          placeholder="Selecciona un embajador (*)"
                          :disabled="
                              secondReagendar || secondCitaDesdeCalendario
                            "
                          @input="llenarEspecialidadesDoctor(true)"
                      >
                            <span slot="no-options"
                            >No hay embajadores disponibles</span
                            >
                      </v-select>
                      <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                      />
                    </b-form-group>
                  </validation-provider>
                </div>
                <div v-else>
                  <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                  >
                    <label>Doctor</label>
                    <validacion/>
                    <b-form-group>
                      <v-select
                          :options="listaDoctoresFiltro"
                          :filterable="false"
                          @search="filtroDoctores"
                          v-model="datosFormulario.idDoctor"
                          :reduce="(variable) => variable.id"
                          label="nombre"
                          placeholder="Selecciona un doctor (*)"
                          :disabled="
                              secondReagendar ||
                              secondCitaDesdeCalendario ||
                              citaIsOverbooking
                            "
                          @input="llenarEspecialidadesDoctor(true)"
                      >
                            <span slot="no-options"
                            >No hay doctores disponibles</span
                            >
                      </v-select>
                      <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                      />
                    </b-form-group>
                  </validation-provider>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                    v-if="
                        !datosFormulario.citaEmbajador &&
                        !datosFormulario.esPacienteNuevo
                      "
                >
                  <label>Especialidad</label>
                  <validacion/>
                  <b-spinner small v-if="loadingEspecialidadesDoc"/>
                  <b-form-group v-else>
                    <v-select
                        id="idEspecialidad"
                        style="width: 100%"
                        :options="listaEspecialidadesDoctorFiltro"
                        :filterable="false"
                        @search="filtroEspecialidadesDoctor"
                        v-model="datosFormulario.idEspecialidad"
                        :reduce="(variable) => variable.id"
                        label="nombre"
                        placeholder="Selecciona una especialidad"
                        :disabled="
                            secondReagendar ||
                            secondCitaDesdeCalendario ||
                            citaIsOverbooking
                          "
                    >
                          <span slot="no-options"
                          >No hay especialidades disponible</span
                          >
                    </v-select>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                    v-if="
                        !datosFormulario.citaEmbajador &&
                        !datosFormulario.esPacienteNuevo
                      "
                >
                  <label>Tratamiento</label>
                  <validacion/>
                  <b-form-group>
                    <v-select
                        style="width: 100%"
                        :options="listaTratamientosFiltro"
                        :filterable="false"
                        @search="filtroTratamientos"
                        :disabled="datosFormulario.esPacienteNuevo"
                        v-model="datosFormulario.idTratamiento"
                        :reduce="(variable) => variable.id"
                        label="nombre"
                        placeholder="Selecciona un tratamiento"
                        id="idTratamiento"
                    >
                          <span slot="no-options"
                          >No hay tratamientos disponibles</span
                          >
                    </v-select>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>

                <div
                    v-if="
                        !datosFormulario.citaEmbajador &&
                        datosFormulario.esPacienteNuevo
                      "
                >
                  <label>Tratamiento:</label>
                  {{ datosFormulario.nombreTratamiento }}
                </div>
              </b-col>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                    v-if="!datosFormulario.citaEmbajador"
                >
                  <label>Sillón</label>
                  <validacion/>
                  <b-form-group>
                    <b-select
                        id="idSillon"
                        placeholder="sillón"
                        :options="getListNumeroSillonesClinica"
                        :disabled="secondCitaDesdeCalendario || citaIsOverbooking"
                        v-model="datosFormulario.sillon"
                    ></b-select>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="datosFormulario.citaEmbajador"
            >
              <label>Sillón</label>
              <validacion/>
              <b-form-group>
                <v-select
                    id="idSillonEmbg"
                    style="width: 100%"
                    :options="listaSillonesEmbajadorFiltro"
                    :filterable="false"
                    @search="filtroSillonesEmbajador"
                    v-model="datosFormulario.sillon"
                    :reduce="(variable) => variable.valor"
                    label="nombre"
                    placeholder="Selecciona una sillón de embajador"
                    :disabled="secondReagendar || secondCitaDesdeCalendario"
                >
                  <span slot="no-options">No hay sillones disponibles</span>
                </v-select>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>

            <b-row>
              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <label>Hora inicio</label>
                  <validacion/>
                  <b-form-group>
                    <vue-timepicker
                        id="idHoraInicio"
                        :disabled="citaIsOverbooking"
                        v-model="datosFormulario.horaInicio"
                        hide-disabled-items
                        format="HH:mm"
                        :minute-interval="15"
                        :hour-range="rangoHoraForm"
                        hide-clear-button
                    ></vue-timepicker>

                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col>
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <label>Hora fin</label>
                  <validacion/>
                  <b-form-group>
                    <vue-timepicker
                        id="idHoraFin"
                        v-model="datosFormulario.horaFin"
                        hide-disabled-items
                        format="HH:mm"
                        :minute-interval="15"
                        :hour-range="rangoHoraForm"
                        hide-clear-button
                        :disabled="citaIsOverbooking"
                    ></vue-timepicker>

                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" v-if="rangoHoraClinica !== undefined">
                Horario(s) Clinica:
                <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                    hc
                  }}
                </b-badge>
              </b-col>
              <b-col cols="12" v-else>
                <validacion
                    texto="Tu clinica no cuenta con ningún horario"
                />
              </b-col>

              <div>
                <b-col
                    cols="12"
                    v-if="!rangoHoraFormEsValido && !citaIsOverbooking"
                >
                  <validacion texto="Selecciona un horario válido"/>
                </b-col>
              </div>
            </b-row>

            <div class="mt-3 col-md-12"></div>

            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Observaciones</label>
              <validacion/>
              <b-form-group>
                <b-form-textarea
                    id="idObservaciones"
                    v-model="datosFormulario.comentario"
                    placeholder="Introduce tus observaciones"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>

            <div>
              <b-form-checkbox id="checkbox-1" v-model="citaAdministrativa">
                Marca esta opción si tu cita es administrativa
              </b-form-checkbox>
            </div>

            <div class="mt-2 col-12 d-flex justify-content-center">
              <div class="d-flex justify-content-center"  v-if="datosFormulario.esPacienteVIP">
                <em class="mr-2"  v-b-tooltip.hover.top.v-light
                    title="Este Paciente es MISD"
                    aria-label="Paciente MISD">
                  <font-awesome-icon :icon="['fas', 'crown']" size="md" style="color: #FFD43B;" />
                </em>
                <span>EL PACIENTE AL QUE SE LE ASIGNARÁ LA CITA ES MISD</span>
              </div>
            </div>

            <b-button
                ref="submitAgregarAgenda"
                type="submit"
                style="visibility: hidden"
            ></b-button>
          </b-form>
        </validation-observer>

        <div class="mt-2 col-md-12"></div>
        <div class="mt-2 col-md-12"></div>
      </div>
      <template v-slot:modal-footer>
        <b-button
            variant="outline-info"
            @click="submitAgregarAgenda"
        >
          <span v-if="!guardando">Guardar</span>
          <span v-if="guardando">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
        </b-button>
        <b-button
            variant="outline-secondary"
            @click="
                  second = false;
              "
            style="margin-left: 10px"
        >Cancelar
        </b-button>
      </template>

    </b-modal>


    <b-modal
        id="modalNuevaCitaV2"
        size="xl"
        v-model="modalNuevaCita"
        scrollable
        v-if="clinicaEstaSeleccionada"
        no-close-on-backdrop
        hide-footer
    >
      <template #modal-header >
        <div style="display: flex;width: 100%;">
          <div class="detalle-formulario" style="flex: 1;">
              <em class="cita_svg color-icono-modal" style="height: 25px;"></em>
            <label class="detalle-formulario-h1 ml-3" style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;">
              <template v-if="datosPreCita.citaSobreAgendar">Agendar cita para sobre agendamiento</template>
              <template v-else-if="datosPreCita.citaReagendar">Reagendar cita {{datosPreCita.citaEmbajador?' embajador' : ''}}</template>
              <template v-else>Agendar cita {{datosPreCita.citaEmbajador?' embajador' : ''}}</template>
            </label>

          </div>
          <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                    @click="modalNuevaCita = false; datosDeCitaCalendario=null">
            <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
          </b-button>
        </div>
      </template>

      <div class="modalPadding" v-if="modalNuevaCita">
        <nuevaCita
            :datosPreCita="datosPreCita"
            :idClinica="datosBusqueda.clinica.clinicaID"
            :vistaModal="true"
            :empleadosEsp="empleadosEsp"
            @cerrarModal="cerrarModalNuevaCitaV2"
            @guardarNuevaCitaV2="guardarNuevaCitaV2"
            :datosCalendario="datosDeCitaCalendario"/>
      </div>


    </b-modal>

    <b-modal
        size="xl"
        v-model="showDetail"
        id="modDetalleCita"
        hide-header
        hide-footer
        scrollable

    >
      <DetalleDeCita :datosDetalleProp="datosDetalle"
                     :datosDetalleOriginal="datosDetalleOriginal"
                     :datosDetalleOverbookingProp="datosDetalleOverbooking"
                     :filtros="filtros"
                     :pacienteSeleccionado="pacienteSeleccionado"
                     :fechaLlegada="fechaLlegada !== null ? true : null"
                     :listaSINOFiltro="listaSINOFiltro"
                     :datosBusqueda="datosBusqueda"
                     @obtenerImagenPlan="obtenerImagenPlan"
                     @buscarAgenda="buscarAgenda"
                     @reagendarCita="reagendarCita"
                     @activarModalEspera="activarModalEspera"
                     @llenarDatosListaEspera="llenarDatosListaEspera"
                     @sobreAgendar="sobreAgendar"
                     @sobreAgendable="sobreAgendable"
                     @deshabilitarSobreAgendable="deshabilitarSobreAgendable"
                     ref="detalleDeCita"
      ></DetalleDeCita>


    </b-modal>

    <b-modal
        size="lg"
        v-model="modalAvisoOverbooking"
        id="modCancelarCita"
        title="Aviso"
        scrollable>
      <div class="p-3">
        <p>No se puede hacer overbooking, debido al indicador de confianza que presenta el(los) paciente(s)
          actualmente agendado(s) ó, sobrepasan el 100% de probabilidad de asistencia a cita.</p>
        <div class="d-flex justify-content-center mt-4 contenedorTablaSinColor">
          <b-table

              v-if="!overbookListaEspera"
              thead-tr-class="columnasTablaSinColor"
              :items="citasAgendadas"
              :fields="encabezadosOverbook"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              :hover="true"
              :small="true"
              style="font-size: 13px; padding: 0.75rem;"
              responsive
              fixed
          >
            <template v-slot:cell(Porcentaje)="row">
                          <span>
                            {{ row.item.indicadorProbabilidad * 10 }}%
                          </span>
            </template>

          </b-table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
            variant="outline-info"
            @click="busquedaOverbooking = true; modalAvisoOverbooking = false;"
        >
          <span v-if="!guardando">Buscar overbooking</span>
          <span v-if="guardando">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
        </b-button>
        <b-button
            variant="outline-secondary"
            @click="
            modalAvisoOverbooking = false;

            "
            style="margin-left: 10px"
        >Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal
        size="lg"
        v-model="showDialogEnviaListEspera"
        id="modEnviaListEspera"
        title="Enviar a lista de espera"
        scrollable>
      <b-spinner v-if="showDialogEnviaListEspera"/>
      <div v-else>
        <p>Seleccione un motivo y comentarios sobre el porqué se enviará este paciente a lista de espera.</p>

        <b-row class="mt-3">

          <b-col class="col-6">
            <label>Paciente:</label>
            <b-form-input
                id="fechacitafin-datepicker"
                v-model="datosDetalle.nombrePaciente"
                class="mb-2"
                disabled
            ></b-form-input>
          </b-col>
          <b-col class="col-6">
            <label>Motivo:</label>
            <v-select

                label="descripcion"
                :options="listaMotivo"
                placeholder="Motivos de envío a lista de espera"
                v-model="motivoEspera.idMotivoEspera"
                :reduce="(item) => item.id"
            >
              <span slot="no-options">No hay motivos disponibles</span>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha inicio de cita solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaInicioCitaSoli"/>
                <b-form-datepicker
                    id="fechacita-datepicker"
                    labelNoDateSelected="Fecha inicio de cita solicitada"
                    v-model="datosFormulario.fechaInicio"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha fin de cita Solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaFinCitaSoli"/>
                <b-form-datepicker
                    id="fechacitafin-datepicker"
                    labelNoDateSelected="Fecha fin de cita Solicitada"
                    v-model="datosFormulario.fechaFin"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="text-left">
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha fin de cita perdida o cancelada </label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaFinCitaPerdida"/>
                <b-form-datepicker
                    labelNoDateSelected="Fecha de cita Solicitada"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    v-model="datosFormulario.fechaCitaPerdida"
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <b-form-group align="left">
              <label>Días de exclusión:</label>
              <v-select
                  style="width: 100%"
                  name="dia"
                  placeholder="--Seleccionar--"
                  label="descripcion"
                  multiple
                  :options="listaDias"
                  v-model="datosFormulario.dias"
              ><span slot="no-options">No hay dias disponibles</span>
              </v-select>
            </b-form-group>
            <b-form-invalid-feedback
                :state="datosFormulario.dias!= null && datosFormulario.dias.length > 0"
            >
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-center">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora inicio</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraInicio"
                    v-model="datosFormulario.horaInicio"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora fin</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraFin"
                    v-model="datosFormulario.horaFin"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" v-if="rangoHoraClinica !== undefined">
            Horario(s) Clinica:
            <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                hc
              }}
            </b-badge>
          </b-col>
          <b-col cols="12" v-else>
            <validacion
                texto="Tu clinica no cuenta con ningún horario"
            />
          </b-col>

          <div>
            <b-col
                cols="12"
                v-if="!rangoHoraFormEsValido"
            >
              <validacion texto="Selecciona un horario válido"/>
            </b-col>
          </div>
        </b-row>

        <b-row class="mt-4">
          <b-col class="col-2"><label>Comentarios:</label></b-col>
        </b-row>
        <b-row>
          <b-col class="col-12">
            <b-form-textarea
                id="textarea"
                v-model="motivoEspera.comentario"
                placeholder="Comentarios"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>

      <div class="mt-2 col-12 d-flex justify-content-center">
        <div class="d-flex justify-content-center"  v-if="datosDetalle.esPacienteVIP">
          <em class="mr-2"  v-b-tooltip.hover.top.v-light
              title="Este Paciente es MISD"
              aria-label="Paciente MISD">
            <font-awesome-icon :icon="['fas', 'crown']" size="md" style="color: #FFD43B;" />
          </em>
          <span>EL PACIENTE AL QUE SE LE ASIGNARÁ LA CITA ES MISD</span>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="outline-info" @click="llenarDatosEsperaOverbook"
        >Aceptar
        </b-button
        >
        <b-button
            variant="outline-secondary"
            @click="showDialogEnviaListEspera = false"
        >Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal
        size="xl"
        v-model="showDialogModalBandejaEspera"
        scrollable>

      <template #modal-title>
        <em class="cita_svg color-icono-modal" style="height: 20px;"></em> Bandeja de lista de espera
      </template>

      <ListaEspera :idClinica="datosBusqueda.clinica.clinicaID" :empleadosEsp="empleadosEsp"></ListaEspera>


      <template v-slot:modal-footer>
        <b-button
            variant="outline-secondary"
            @click="showDialogModalBandejaEspera = false"
        >Cerrar
        </b-button>
      </template>
    </b-modal>

    <b-modal
        v-model="showDialogEnviaListEsperaDatos"
        id="modEnviaListEspera"
        title="Enviar a lista de espera"
        scrollable
        size="xl"
        hide-header
        hide-footer
    >

      <EnviarAListaDeEspera
          :datosDetalle="datosDetalle"
          :hayPaciente="hayPaciente"
          :listaDias="listaDias"
          :datosFormulario="datosFormulario"
          :fechaMinima="fechaMinima"
          :rangoHoraForm="rangoHoraForm"
          :rangoHoraClinica="rangoHoraClinica"
          :rangoHoraFormEsValido="rangoHoraFormEsValido"
          @guardarListaEsperaDatos="guardarListaEsperaDatos"
      ></EnviarAListaDeEspera>


    </b-modal>


    <b-modal
        v-model="showDialogEnviaListEsperaCalendario"
        id="modEnviaListEspera"
        title="Enviar a lista de espera"
        scrollable
        size="lg"
        hide-footer
    >

      <EnviarAListaEsperaCalendario
          :mostrarBusquedaPaciente="mostrarBusquedaPaciente"
          :datosFormulario.sync="datosFormulario"
          @llenarPacientesClinica="llenarPacientesClinica"
          :listaPacientes.sync ="listaPacientes"
          :loadingPacientes.sync ="loadingPacientes"
          :secondReagendar.sync="secondReagendar"
          :listaDias="listaDias"
          :fechaMinima="fechaMinima"
          :rangoHoraForm="rangoHoraForm"
          :rangoHoraClinica="rangoHoraClinica"
          :rangoHoraFormEsValido="rangoHoraFormEsValido"
          :listaDoctores="listaDoctores"
          :listaDoctoresFiltro="listaDoctoresFiltro"
          :loadingFechaFinCitaPerdida="loadingFechaFinCitaPerdida"
          :listaEspecialidadesDoctor.sync="listaEspecialidadesDoctor"
          :listaTratamientos.sync="listaTratamientos"
          :listaMotivo="listaMotivo"
          :loadingFechaInicioCitaSoli.sync="loadingFechaInicioCitaSoli"
          :loadingFechaFinCitaSoli.sync="loadingFechaFinCitaSoli"
          @tagMotivoCita="tagMotivoCita"
          @llenarEspecialidadesDoctor="llenarEspecialidadesDoctor"
          @llenarTratamientos="llenarTratamientos"
          @limpiarPacienteSeleccionado="limpiarPacienteSeleccionado"
          @guardarListaEsperaDatos="guardarListaEsperaDatos"
          :tagmotivocitaDatosArrayFiltro="tagmotivocitaDatosArrayFiltro"
          :filtrotagmotivocitaDatos="filtrotagmotivocitaDatos"
      ></EnviarAListaEsperaCalendario>
    </b-modal>


    <b-modal
        v-model="mostrarErrorVal" hide-header-close hide-footer
        size="md"
    >
      <b-container fluid style="font-size: 14px;">
        <div style="text-align: center" class="mb-4">
          <em class="close_round_svg" style="height: 100px"></em>
        </div>
        <div style="font-weight: bolder; text-align: center;" class="mt-2">Paciente no es candidato a sobre agendar por estos criterios:</div>
        <div v-html="msgValidacion" style="font-size: 12px;"  class="mt-2"/>
        <div style="text-align: center" class="mt-4">
          <b-button pill @click="mostrarErrorVal = false">Enterado</b-button>
        </div>
      </b-container>

    </b-modal>


  </div>
</template>

<script>
import Header from "../components/Header.vue";
import miniToastr from "mini-toastr"; //ES6
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import CalendarioSemanal from "@/components/calendario/CalendarioSemanal";
import CalendarioDia from "@/components/NuevaAgenda/CalendarioDia";
import ListaEspera from "../views/modalsAgendaInteligente/ListaEspera";
import DetalleDeCita from "@/components/NuevaAgenda/DetalleDeCita";
import EnviarAListaDeEspera from "@/components/NuevaAgenda/EnviarAListaDeEspera";
import EnviarAListaEsperaCalendario from "@/components/NuevaAgenda/EnviarAListaEsperaCalendario";
import nuevaCita from "@/components/NuevaAgenda/nuevaCita/nuevaCita";

export default {
  name: "ScheduleNuevo",
  components: {
    EnviarAListaEsperaCalendario,
    EnviarAListaDeEspera,
    DetalleDeCita,
    CalendarioDia,
    CalendarioSemanal,
    Header,
    ListaEspera,
    nuevaCita,
  },
  props: {
    msg: String
  },
  computed: {
    rows() {
      return this.horarioDisponibleOverbooking.length;
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    clinicaEstaSeleccionada() {
      return (
          this.datosBusqueda.clinica.clinicaID !== undefined &&
          this.datosBusqueda.clinica.clinicaID !== null &&
          this.datosBusqueda.clinica.clinicaID > 0
      );
    },
    clinicaId() {
      return this.datosBusqueda.clinica.clinicaID;
    },
    idEspecialidadForm: function () {
      if (this.datosFormulario !== undefined && this.datosFormulario !== null) {
        return this.datosFormulario.idEspecialidad;
      }
      return null;
    },

    obtenerHorarioClinicaForm: function () {
      if (
          this.datosFormulario !== undefined &&
          this.datosFormulario !== null &&
          this.datosFormulario.fechaCita !== undefined &&
          this.datosFormulario.sillon !== undefined
      ) {
        const pos =
            this.$moment(this.datosFormulario.fechaCita).format("YYYY/MM/DD") +
            "-" +
            this.datosFormulario.sillon;
        if (this.horariosClinica[pos] !== undefined) {
          return this.horariosClinica[pos];
        }
      }
      return undefined;
    },
    rangoHoraClinica: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.original;
      } else {
        return undefined;
      }
    },
    rangoHoraForm: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.horas;
      } else {
        return [];
      }
    },
    rangoHoraFormEsValido: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (
          val !== undefined &&
          this.datosFormulario.horaInicio.HH !== undefined &&
          this.datosFormulario.horaInicio.mm !== undefined &&
          this.datosFormulario.horaFin.HH !== undefined &&
          this.datosFormulario.horaFin.mm !== undefined
      ) {
        let diaFormato = this.$moment(
            this.datosFormulario.fechaCita,
            "DD/MM/YYYY"
        ).format("YYYY/MM/DD");
        if (!diaFormato._isValid) {
          diaFormato = this.$moment(this.datosFormulario.fechaCita).format(
              "YYYY/MM/DD"
          );
        }

        const horaInicio = this.$moment(
            diaFormato +
            " " +
            this.datosFormulario.horaInicio.HH +
            ":" +
            this.datosFormulario.horaInicio.mm +
            ":00"
        );
        const horaFin = this.$moment(
            diaFormato +
            " " +
            this.datosFormulario.horaFin.HH +
            ":" +
            this.datosFormulario.horaFin.mm +
            ":00"
        );

        if (horaInicio >= horaFin) {
          return false;
        }

        let esValido = false;
        val.horasMinutosDate.forEach((it) => {
          if (horaInicio >= it.horaInicio && horaFin <= it.horaFin) {
            esValido = true;
          }
        });
        return esValido;
      }
      return false;
    },
    getListNumeroSillonesClinica: function () {
      const list = [];
      for (let i=1; i<=this.getNumeroSillonesClinica; i++) {
        list.push({text:i, value:i});
      }
      return list;
    },
    getNumeroSillonesClinica: function () {
      return this.calcularNumeroSillones();
    },
    fechaMinima: function () {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    mostrarBusquedaPaciente: function () {
      return (
          this.datosFormulario !== undefined &&
          (this.datosFormulario.idPaciente === undefined ||
              this.datosFormulario.idPaciente < 1)
      );
    },
    obtenerProximasCitas: function () {
      let proximasCitas = [];
      const fechaActual = this.$moment();

      this.citasSinProcesar.forEach(c => {
        if(c.idEstatusCita === 1 || c.idEstatusCita === 5 || c.idEstatusCita === 11 || c.idEstatusCita === 24
            || c.idEstatusCita === 26  || c.idEstatusCita === 28)
        c.fechaInicioCompletaHoraMin = this.$moment(c.fechaCitaSinZona+' '+ c.horaInicioCasilla);
        c.fechaFinCompletaHoraMin = this.$moment(c.fechaCitaSinZona+' '+ c.horaFinCasilla);

        if ((c.fechaInicioCompletaHoraMin >= fechaActual
            && c.fechaInicioCompletaHoraMin.diff(fechaActual, 'minutes') <= 195)
            || (c.fechaInicioCompletaHoraMin <= fechaActual
                && c.fechaInicioCompletaHoraMin.diff(fechaActual, 'minutes') >= -15)
        ) {
          proximasCitas.push(c);
        }
      });

      return proximasCitas;
    }
  },
  watch: {
    pacienteSeleccionado: function (val) {
      if (val != null) {
        this.consultarDetallePorPaciente();
      }
    },
    idEspecialidadForm: function () {
      this.llenarTratamientos(this.idEspecialidadForm);
    },
    "datosFormulario.fechaCita": function () {
      this.buscarHorariosClinica();
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    hayPaciente: false,
    semanalDiaria: false,
    mostrarBarraLateral: false,
    mostrarBarraLateralCitas: false,
    listaCitas: [],
    filtros: {
      options: {
        motivosCita: [],
        canalCita: [],
        estatusCita: [],
        especialidades: [],
        planes: [],
        tipos: [],
        doctores: [],
        sillones: []
      },
      selects: {
        porcentajeConfianza: [0, 100],
        canalCita:[],
        montoPti: [0, 200000],
        motivosCita: [],
        estatusCita: [],
        especialidades: [],
        pacienteNatural: false,
        pacientePlan: false,
        todosPlanes: false,
        planes: [],
        tipos: [],
        nombreDoctor: "",
        doctores: [],
        sillones: []
      },
    },

    pacienteBusqueda: [],
    motivoEspera: {
      idPaciente: null,
      idMotivoEspera: null,
      comentario: null
    },
    showDialogEnviaListEspera: false,
    showDialogModalBandejaEspera: false,
    showDialogEnviaListEsperaDatos: false,
    showDialogEnviaListEsperaCalendario: false,

    modalAvisoOverbooking: false,
    citasAgendadas: false,
    buscarOverbooking: false,
    overbookListaEspera: false,
    semana: {},
    dias: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    listaMotivo: [],
    loadingFechaFinCitaPerdida: false,
    loadingFechaInicioCitaSoli: false,
    loadingFechaFinCitaSoli: false,
    styleMenu: "fade-in-right sticky-container",
    showDetail: false,
    guardando: false,
    loading: false,
    loadingCAl: false,
    loadingHorariosClinica: false,
    loadingDoctoresClinica: false,
    loadingDoctoresEsp: false,
    loadingDoctores: false,
    loadingPacientes: false,
    loadingEspecialidadesDoc: false,
    datosBusqueda: {
      tratamientoID: 12,
      clinica: {
        clinicaID: null,
        nombre: "-",
      },
      clinicaNombre: "-",
      fechaInicio: undefined,
      fechaFin: undefined,
      fechaActual: new Date(),
      idEspecialidad: null,
      empleadoId: null,
    },
    datosFormulario: [],
    datosDetalle: [],
    datosDetalleOverbooking: null,
    datosPreCita: null,
    citasSinProcesar: [],
    eventos: [],
    horariosDoctor: [],
    horariosClinica: [],

    encabezados: [
      {
        key: "id",
        label: "Id",
      },
      {
        key: "name",
        label: "Nombre del Paciente",
      },
    ],
    registrosPorPagina: 15,
    paginaActual: 1,

    modalNuevaCita: false,
    second: false,
    secondCitaDesdeCalendario: false,
    secondReagendar: false,

    listaClinicas: [],
    listaClinicasFiltro: [],
    listaEspecialidades: [],
    listaEspecialidadesDoctor: [],
    listaEspecialidadesDoctorFiltro: [],
    listaTratamientos: [],
    listaTratamientosFiltro: [],
    listaMotivosHerramientas: [],
    listaDoctores: [],
    listaDoctoresFiltro: [],
    listaPacientes: [],
    listaMotivosCancelacion: [],
    listaKitsPacienteNuevo: [],
    listaSillonesEmbajador: [],
    listaSillonesEmbajadorFiltro: [],
    listaDias: [],
    empleadosEsp: [],
    idEspecialidadFiltro: null,

    tipoBusqueda: 1,

    tagmotivocitaDatosArray: [],
    tagmotivocitaDatosArrayFiltro: [],
    idCita: null,

    nombrePaciente: null,
    citaAdministrativa: false,
    pacienteSeleccionado: null,
    datosDetalleOriginal: null,
    listaSINO: [
      {
        etiqueta: "SI",
        valor: true,
      },
      {
        etiqueta: "NO",
        valor: false,
      },
    ],
    listaSINOFiltro: [],
    fechaLlegada: null,
    busquedaOverbooking: false,
    colorCita: "",
    horarioDisponibleOverbooking: [],
    semanaActual: "",
    citaIsOverbooking: false,
    fieldsCitas: [
      {
        key: "fechaCitaSinZona",
        label: "Fecha de la cita",
      },
      {
        key: "horaInicioCasilla",
        label: "Hora inicio",
      },
      {
        key: "horaFinCasilla",
        label: "Hora fin",
      },
      {
        key: "sillon",
        label: "Sillón",
      },
      {
        key: "agendar",
        label: "Agendar",
      },
    ],
    encabezadosOverbook: [
      {
        key: "idPaciente",
        label: "ID paciente",
      },
      {
        key: "nombrePaciente",
        label: "Nombre del paciente",
      },
      {
        key: "indicadorProbabilidad",
        label: "Indicador de probabilidad",
      },
      "Porcentaje"

    ],
    currentPage: 1,
    perPage: 5,
    marcadorPorcentConfianza: {
      '0': '0%',
      '100': '100%'
    },

    valorInicialMontoPti: 0,
    valorFinalMontoPti: 200000,

    mostrarErrorVal: false,
    msgValidacion: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    datosDeCitaCalendario: null,
  }),
  filters: {
    date(date) {
      return new Intl.DateTimeFormat("en-US").format(date);
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.listaSINOFiltro = this.listaSINO;
    this.loading = true;
    if (this.$localStorageService.getIdEmpleado() !== undefined) {
      this.datosBusqueda.clinica.empleadoId =
          this.$localStorageService.getIdEmpleado();
    }
    if (this.$localStorageService.getIdClinica() !== undefined) {
      this.datosBusqueda.clinica.clinicaID = this.$localStorageService.getIdClinica();
    }

    this.llenarClinicas();
    this.obtenerDoctoresEspecialistas();

    this.listaSillonesEmbajador = [
      {nombre: "E1", valor: 100},
      {nombre: "E2", valor: 101},
    ];
    this.listaSillonesEmbajadorFiltro = this.listaSillonesEmbajador;
    if(localStorage.getItem("abrirAgendaEE") === 'true'){
      this.mostrarModalCrearCita(true);
    }
    localStorage.setItem("abrirAgendaEE", false)

    if(localStorage.getItem("vistaProximasCitas") === 'true'){
      localStorage.vistaProximasCitas = false;
      this.semanalDiaria = true;
      this.mostrarBarraLateral = true;
      this.mostrarBarraLateralCitas = true;
    }

    this.obtenerDias();
  },
  methods: {
    validarCambio(){
      let final = this.valorFinalMontoPti - this.valorInicialMontoPti;

      if (final < 0 ){

        if (this.valorInicialMontoPti > this.valorFinalMontoPti){
          this.$swal({
            position: "top-end",
            showConfirmButton: true,
            timer: 4200,
            toast: true,
            icon: "info",
            title: "El monto Final no puede ser menor al monto inicial del pti",
          })
        }

      } else{
        this.filtros.selects.montoPti[0] = this.valorInicialMontoPti;
        this.filtros.selects.montoPti[1] = this.valorFinalMontoPti;
        this.procesarBusquedaAgenda(this.listaCitas)
      }

    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) ){
          $event.preventDefault();
        }
    },
    limpirFiltroMontoPti(){
      this.valorInicialMontoPti = 0;
      this.valorFinalMontoPti = 200000;

      this.filtros.selects.montoPti[0] = this.valorInicialMontoPti;
      this.filtros.selects.montoPti[1] = this.valorFinalMontoPti;
      this.procesarBusquedaAgenda(this.listaCitas)
    },
    cambiarVistaSemanal() {
      this.semanalDiaria = false;
      this.seleccionarFecha(this.datosBusqueda.fechaActual, false);
    },
    cambiarVistaDiaria() {
      this.semanalDiaria = true;
      this.seleccionarFecha(this.datosBusqueda.fechaActual, false);
    },
    llenarDatosEsperaOverbook() {
      let datos = {
        idMotivoEspera: this.motivoEspera.idMotivoEspera,
        idPaciente: this.datosDetalle.idPaciente,
        comentario: this.motivoEspera.comentario,
        fechaFin: new Date(this.datosFormulario.fechaFin),
        fechaInicio: new Date(this.datosFormulario.fechaInicio),
        horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
        horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
        idEstatusListaEspera: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEspecialidad: this.datosDetalle.tratamientos[0].idEspecialidad,
        idTratamiento: this.datosDetalle.tratamientos[0].idTratamiento,
        diasExclusion: this.datosFormulario.dias,
      };

      this.guardarListaEsperaDatos(datos);
    },

    llenarDatosListaEspera(procesoManual, bandera) {
      if (procesoManual) {
        let indice = null;
        let especialidad = null;
        if(bandera !== 1) {
          indice = this.datosFormulario.idEspecialidad.indexOf(",");
          especialidad = indice !== -1 ? this.datosFormulario.idEspecialidad.substring(0, indice) : this.datosFormulario.idEspecialidad ;
        }else{
          especialidad = this.datosFormulario.idEspecialidad;
        }



        let datos = {
          idMotivoEspera: this.datosFormulario.idMotivoEspera,
          idPaciente: this.datosFormulario.idPaciente,
          comentario: this.datosFormulario.comentario,
          fechaFin: new Date(this.datosFormulario.fechaFin),
          fechaInicio: new Date(this.datosFormulario.fechaInicio),
          horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
          horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
          idEstatusListaEspera: 1,
          idClinica: this.$localStorageService.getIdClinica(),
          idEspecialidad: especialidad,
          idTratamiento: this.datosFormulario.idTratamiento,
          diasExclusion: this.datosFormulario.dias,
          procesoManual: procesoManual
        };

        let mostrarMensajeConfirmacion = bandera === 1 ? true : false;
        this.guardarListaEsperaDatos(datos, mostrarMensajeConfirmacion);

      }else {
       this.procesoListaEsperaAutomatica();
      }

    },
    procesoListaEsperaAutomatica(){

      let fechafin = new Date(this.datosDetalle.fechaCita);
      fechafin.setDate(fechafin.getDate() + 7);

      let indice = this.datosDetalle.idEspecialidadDoctor.indexOf(",");
      let especialidad = indice !== -1 ? this.datosDetalle.idEspecialidadDoctor.substring(0, indice): this.datosDetalle.idEspecialidadDoctor;

      let datos = {
        idMotivoEspera: 5,
        idPaciente: this.datosDetalle.idPaciente,
        comentario: "",
        fechaFin: fechafin,
        fechaInicio: new Date(this.datosDetalle.fechaCita),
        horafin: this.datosDetalle.horaFin,
        horaInicio: this.datosDetalle.horaInicio,
        idEstatusListaEspera: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEmpleado:this.datosDetalle.idDoctor,
        idEspecialidad: especialidad,
        idTratamiento: this.datosDetalle.tratamientos[0].idTratamiento,
        diasExclusion: [],
        procesoManual: false,
        idTagMotivoCita: this.datosDetalle.idTagMotivoCita,
        idCita: this.datosDetalle.idCita
      };

      this.guardarListaEsperaDatos(datos, false);
    },
    traerMotivoEspera() {
      const url = this.$api + "catalogos/obtenerMotivosEspera";
      this.$http
          .get(url)
          .then((response) => {
            this.listaMotivo = response.data.data;
          })
          .catch((err) => {
            this.mostrarError(err);
          });
    },
    obtenerDias() {
      this.$http
          .get(this.$api + "catalogos/obtenerDias")
          .then((response) => {
            if (response.status === 200) {
              this.listaDias = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    pasarDatos(){
      this.datosFormulario.idPaciente = this.datosDetalle.idPaciente;
      this.datosFormulario.idEspecialidad = this.datosDetalle.idEspecialidadDoctor;
      this.datosFormulario.idTratamiento = this.datosDetalle.tratamientos[0].idTratamiento;
      this.datosFormulario.idMotivoEspera = 2;
    },

    async activarModalEspera(esPaciente) {
      this.hayPaciente = esPaciente != null && esPaciente ? esPaciente : false;

      if (this.hayPaciente){
        this.showDialogEnviaListEsperaDatos = true;
      }else{
        this.showDialogEnviaListEsperaCalendario = true
      }

      this.obtenerDias();
      this.overbookListaEspera = false;
      this.mostrarModalCrearCita(false);
      this.horarioDisponibleOverbooking = [];

      this.traerMotivoEspera();

      const today = this.$moment();
      const year = today.format("YYYY");

      var weeknumber = this.$moment(today, "MM-DD-YYYY").week();

      this.semanaActual = year + "-W" + weeknumber;
      if (this.hayPaciente){
        this.pasarDatos()
      }

    },
    mostrarBandejaEspera() {
      this.showDialogModalBandejaEspera=true
    },

    guardarListaEsperaDatos(datos, mostrarMensajeConfimacion) {
      this.loading = true;

      this.$http
          .post(
              this.$api +
              "agendaclinica/listaEspera/guardar", datos
          )
          .then(() => {
            if (mostrarMensajeConfimacion){
              this.showDialogEnviaListEsperaCalendario = false;
              this.$swal.fire({
                icon: "success",
                title: "Aviso",
                text: "Se agregó a la lista de espera de manera éxitosa",
              });
            }else {

              this.$refs.detalleDeCita.cancelarCitaServ();
            }

            this.showDialogEnviaListEsperaDatos = false;
            this.showDialogEnviaListEspera = false;
          })
          .catch((error) => {
            console.error("Error", error);
            if (mostrarMensajeConfimacion){
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrió un error al enviar a la lista de espera",
              });
            }

          }).finally(()=>{
          this.loading = false;
      });
    },
    cerrarOverbooking() {
      this.busquedaOverbooking = false;
      this.datosFormulario = [];
      this.buscarOverbooking = false;

    },
    obtenerSemana() {
      let fecha = new Date();
      fecha = new Date(this.datosBusqueda.fechaInicio.toISOString());
      const mesSemana = this.$moment(fecha.toISOString()).format("MMMM YYYY");
      this.semana.numeroSemana =
          "Semana " +
          this.$moment(fecha.toISOString()).week() +
          " (" +
          mesSemana.charAt(0).toUpperCase() +
          mesSemana.slice(1) +
          ")";
    },
    cambiarAnteriorSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      if (this.semanalDiaria) {
        fecha.setDate(fecha.getDate() - 1);
      } else {
        fecha.setDate(fecha.getDate() - 7);
      }
      this.seleccionarFecha(fecha, false);
    },

    cambiarSiguienteSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      if (this.semanalDiaria) {
        fecha.setDate(fecha.getDate() + 1);
      } else {
        fecha.setDate(fecha.getDate() + 7);
      }
      this.seleccionarFecha(fecha, false);
    },
    filtroSillonesEmbajador(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaSillonesEmbajadorFiltro = this.listaSillonesEmbajador.filter(
          (em) => {
            return em.nombre.toLowerCase().includes(seach.toLowerCase());
          }
      );
      loading(false);
    },
    filtroTratamientos(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaTratamientosFiltro = this.listaTratamientos.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtroEspecialidadesDoctor(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaEspecialidadesDoctorFiltro =
          this.listaEspecialidadesDoctor.filter((em) => {
            return em.nombre.toLowerCase().includes(seach.toLowerCase());
          });
      loading(false);
    },
    filtroDoctores(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaDoctoresFiltro = this.listaDoctores.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtrotagmotivocitaDatos(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.tagmotivocitaDatosArrayFiltro = this.tagmotivocitaDatosArray.filter(
          (em) => {
            return em.descripcionTagMotivoCita
                .toLowerCase()
                .includes(seach.toLowerCase());
          }
      );
      loading(false);
    },
    filtroClinicas(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaClinicasFiltro = this.listaClinicas.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    agendarOverbooking(datosCita) {
      this.datosFormulario = datosCita;
      this.citaIsOverbooking = true;
      this.second = true;
    },

    verificarOverbooking() {
      this.loading = true;
      let fecha = this.$moment(this.datosFormulario.fechaCita).format(
          "YYYY-MM-DD[T]HH:mm[:00Z]"
      );

      const datosGuardar = {
        especialidad: this.datosFormulario.idEspecialidad,
        empleado: this.datosFormulario.idDoctor,
        fecha: fecha,
      };
      let idPacienteAgendar = this.datosFormulario.idPaciente;
      let citas = [];

      this.$http
          .post(
              this.$api +
              "cita/citasOverBook?idPacienteAgendar=" +
              idPacienteAgendar,
              datosGuardar
          )
          .then((response) => {
            citas = response.data.data;
            if (response.status === 200) {
              this.horarioDisponibleOverbooking = response.data.data.map((it) => {
                var horarioInicio = it.hora_inicio.toString();
                var horarioFin = it.hora_fin.toString();
                if (horarioInicio.length == 3) {
                  horarioInicio = "0" + horarioInicio;
                }
                if (horarioFin.length == 3) {
                  horarioFin = "0" + horarioFin;
                }
                let horaInicio = horarioInicio.substring(0, 2);
                let minutosInicio = horarioInicio.substring(2, 4);
                let horaFin = horarioFin.substring(0, 2);
                let minutosFin = horarioFin.substring(2, 4);
                let fechaSinZona = it.fecha.substring(0, 10);
                return {
                  fechaCita: it.fecha,
                  fechaCitaSinZona: fechaSinZona,
                  horaInicioCasilla: horaInicio + ":" + minutosInicio,
                  horaFinCasilla: horaFin + ":" + minutosFin,
                  sillon: it.sillon,
                  agendar: "agendar",
                  idEspecialidad: it.idespecialidad,
                  idDoctor: it.idempleado,
                  idPaciente: this.datosFormulario.idPaciente,
                  nombrePaciente: this.datosFormulario.nombrePaciente,
                  idClinica: citas.idClinica,
                  idCanalOrigen: 1,
                  idCompania: 1,
                  horaInicio: {
                    HH: horaInicio,
                    mm: minutosInicio,
                  },
                  horaFin: {
                    HH: horaFin,
                    mm: minutosFin,
                  },
                };
              });
              if (this.horarioDisponibleOverbooking.length === 0) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "No se encontraron citas para hacer overbooking",
                  confirmButtonColor: "#0e6ba9",
                  confirmButtonText: "OK",
                });
              }
              this.actualizarNombreClinica(true);
            }
          })
          .catch((error) => {
            console.error(error);
            if (error) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "No se encontraron citas para hacer overbooking",
                confirmButtonColor: "#0e6ba9",
                confirmButtonText: "OK",
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.buscarOverbooking = true;
          });
    },
    onClick(text) {
      alert(`You clicked ${text}!`);
    },
    llenarClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicasAgenda")
          .then((response) => {
            if (response.status === 200) {
              this.listaClinicas = response.data.data;
              this.actualizarNombreClinica(true);
            }
          })
          .catch((error) => {
            this.listaClinicas = Array();
            console.error(error);
          })
          .finally(() => {
            this.llenarPacientesClinica();
          });
    },
    calcularNumeroSillones() {
      if (
          this.datosBusqueda.clinica !== null &&
          this.datosBusqueda.clinica.clinicaID !== undefined &&
          this.datosBusqueda.clinica.clinicaID > 0 &&
          this.listaClinicas !== undefined &&
          this.listaClinicas !== null
      ) {
        const clinica = this.listaClinicas.find(
            (c) => c.id === this.datosBusqueda.clinica.clinicaID
        );
        if (clinica !== undefined) {
          const sillones = this.listaClinicas.find(
              (c) => c.id === this.datosBusqueda.clinica.clinicaID
          ).numeroSillones;
          if (sillones !== undefined && sillones !== null && sillones > 0) {
            return sillones;
          }
        }
      }
      return 1;
    },
    llenarTratamientos(idEspecialidad) {
      if (
          idEspecialidad === undefined ||
          idEspecialidad === null ||
          idEspecialidad === 0
      ) {
        this.listaTratamientos = Array();
        return;
      }

      const listaEspecialidades = [idEspecialidad];
      const params = {
        idClinica: this.datosBusqueda.clinica.clinicaID,
        idsEspecialidad: listaEspecialidades
      }
      this.$http
          .put(
              this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidad",
              params )
          .then((response) => {
            if (response.status === 200) {
              this.listaTratamientos = response.data.data
                  .map((it) => {
                    return {
                      id: it.idTratamiento,
                      nombre: it.nombre,
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaTratamientosFiltro = this.listaTratamientos;
            }
          })
          .catch((error) => {
            console.error("error del methos tratamientos", error);
          });
    },
    async llenarDoctoresEspecialistasClinica(idClinica) {
      this.loadingDoctoresClinica = true;
      this.listaDoctores = [];

      if (
          this.datosFormulario.idPaciente === undefined ||
          this.datosFormulario.idPaciente == null ||
          this.datosFormulario.idPaciente === 0
      ) {
        return;
      }

      const parametros = {
        idClinica: idClinica,
        idPaciente: this.datosFormulario.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
          )
          .then((response) => {
            this.listaDoctores.push(
                ...response.data.data
                    .map((it) => {
                      return {
                        id: it.idEmpleado,
                        nombre:
                            it.numeroEmpleado +
                            " " +
                            it.nombreEmpleado +
                            " (" +
                            this.obtenerEspecialidadesDoctor(it) +
                            ")",
                        especialidades: it.especialidades,
                      };
                    })
                    .filter(
                        (x) =>
                            x.especialidades !== undefined &&
                            x.especialidades.some((it00) => it00.idEspecialidad > 1)
                    )
                    .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
            );
            this.listaDoctoresFiltro = this.listaDoctores;
            this.listaDoctores.push(
                ...this.empleadosEsp.filter((it) => {
                  return !this.listaDoctores.some(
                      (itSome) => itSome.id === it.id
                  );
                })
            );
            this.listaDoctoresFiltro = this.listaDoctores;
          })
          .catch((error) => {
            this.loadingDoctoresClinica = false;
            console.error(error);
          })
          .finally(() => {
            this.loadingDoctoresClinica = false;
          });
    },
    obtenerDoctoresEspecialistas() {
      const parametros = {idClinica: this.datosBusqueda.clinica.clinicaID}
      this.loadingDoctoresEsp = true;

      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/listaDoctoresEspecialistas", parametros
          )
          .then((response) => {
            this.empleadosEsp = response.data.data
                .map((it) => {
                  return {
                    id: it.idEmpleado,
                    nombre:
                        it.numeroEmpleado +
                        " " +
                        it.nombreEmpleado +
                        " (" +
                        it.nombreEspecialidades +
                        ")",
                  };
                })
                .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
          }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.loadingDoctoresEsp = false
      })
    },
    async llenarDoctoresClinica(idClinica) {
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        this.listaDoctores = Array();
        return;
      }

      if (
          this.datosFormulario.idPaciente === undefined ||
          this.datosFormulario.idPaciente == null ||
          this.datosFormulario.idPaciente === 0
      ) {
        return;
      }

      this.loadingDoctoresClinica = true;
      const parametros = {
        idClinica: idClinica,
        idPaciente: this.datosFormulario.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaDoctores = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEmpleado,
                      nombre:
                          it.numeroEmpleado +
                          " " +
                          it.nombreEmpleado +
                          " (" +
                          this.obtenerEspecialidadesDoctor(it) +
                          ")",
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaDoctoresFiltro = this.listaDoctores;
            }
          })
          .catch((error) => {
            this.loadingDoctoresClinica = false;
            console.error(error);
          })
          .finally(() => {
            this.loadingDoctoresClinica = false;
          });
    },
    async llenarDoctoresEmbajadorClinica(idClinica) {
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        this.listaDoctores = Array();
        return;
      }
      this.loadingDoctores = true;
      const parametros = {idClinica: idClinica}
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerListaDoctoresEmbajadorClinica", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaDoctores = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEmpleado,
                      nombre:
                          it.numeroEmpleado +
                          " " +
                          it.nombreEmpleado +
                          " (" +
                          this.obtenerEspecialidadesDoctor(it) +
                          ")",
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaDoctoresFiltro = this.listaDoctores;
            }
          })
          .catch((error) => {
            this.loadingDoctores = false;
            console.error(error);
          })
          .finally(() => (this.loadingDoctores = false));
    },
    llenarEspecialidadesDoctor(limpiarEspecialidad) {
      this.listaEspecialidadesDoctor = Array();
      if (
          this.datosFormulario === undefined ||
          this.datosFormulario.idDoctor === undefined ||
          this.datosFormulario.idDoctor === null ||
          this.datosFormulario.idDoctor === 0
      ) {
        return;
      }

      if (limpiarEspecialidad) {
        this.datosFormulario.idEspecialidad = null;

        if (!this.datosFormulario.esPacienteNuevo) {
          this.datosFormulario.idTratamiento = null;
        }
      }

      this.loadingEspecialidadesDoc = true;
      const parametros = {idEmpleado: this.datosFormulario.idDoctor}
      this.$http
          .post(
              this.$api +
              "colaboradores/obtenerEspecialidadesDoctor", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaEspecialidadesDoctor = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEspecialidad,
                      nombre: it.nombreEspecialidad,
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaEspecialidadesDoctorFiltro =
                  this.listaEspecialidadesDoctor;
            }
          })
          .catch((error) => {
            this.loadingEspecialidadesDoc = false;
            console.error(error);
          })
          .finally(() => {
            this.loadingEspecialidadesDoc = false;
            return this.listaEspecialidadesDoctor;
          });
    },
    llenarPacientesClinica(tipoBusqueda) {
      this.listaPacientes = Array();
      this.tipoBusqueda = tipoBusqueda != null && tipoBusqueda != undefined ? tipoBusqueda : this.tipoBusqueda;
      this.paginaActual = 1;
      if (
          this.datosFormulario === undefined ||
          this.datosFormulario.nombrePacienteBusqueda === undefined ||
          this.datosFormulario.nombrePacienteBusqueda === null ||
          this.datosFormulario.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.datosFormulario.nombrePacienteBusqueda
          .trim()
          .toLowerCase()
          .toUpperCase();

      this.loadingPacientes = true;
      const params = {
        nombrePaciente: inputTxt,
        tipoBusqueda: this.tipoBusqueda
      }
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/obtenerDatosPacientePorOpcionBusqueda",
              params
          )
          .then((response) => {
            if (response.status === 200) {


              if (Array.isArray(response.data.data)) {
                const uniqueAddresses = Array.from(
                    new Set(response.data.data.map((a) => a.id))
                ).map((id) => {
                  return response.data.data.find((a) => a.id === id);
                });
                uniqueAddresses.map((elementDos) => {

                  var data = {
                    id: elementDos.id,
                    name: elementDos.nombre,
                    esPacienteNuevo: elementDos.esPacienteNuevo,
                    esPacienteVIP: elementDos.esPacienteVIP,
                    indicadorProbabilidad: elementDos.indicadorProbabilidad,
                    correo: elementDos.correo,
                    telefono: elementDos.telefono
                  };
                  this.listaPacientes.push(data);
                  return data;
                });

                if (Array.isArray(this.listaPacientes)) {
                  this.listaPacientes.sort(function (a, b) {
                    if (a.id > b.id) {
                      return 1;
                    }
                    if (a.id < b.id) {
                      return -1;
                    }
                    return 0;
                  });
                }
              }
            }
          })
          .catch((error) => {
            miniToastr.info("No se encontraron pacientes");
            console.error("Error", error);
            this.loadingPacientes = false;
          })
          .finally(() => {
            this.loadingPacientes = false;
          });
      return this.listaPacientes;
    },
    getPatientsV2() {
      if ( (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {

        this.loadingPacientes = true;
        this.$http
            .get(
                this.$api +
                "paciente/perfiles/obtenerDatosPacienteAgenda?nombre=" +
                this.nombre.trim() + "&apellidoPaterno=" + this.apellidoPaterno.trim() + "&apellidoMaterno=" + this.apellidoMaterno.trim()
            )
            .then((response) => {
              if (response.status === 200) {


                if (Array.isArray(response.data.data)) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {

                    var data = {
                      id: elementDos.id,
                      name: elementDos.nombre,
                      esPacienteNuevo: elementDos.esPacienteNuevo,
                      indicadorProbabilidad: elementDos.indicadorProbabilidad,
                      correo: elementDos.correo,
                      telefono: elementDos.telefono
                    };
                    this.listaPacientes.push(data);
                    return data;
                  });

                  if (Array.isArray(this.listaPacientes)) {
                    this.listaPacientes.sort(function (a, b) {
                      if (a.id > b.id) {
                        return 1;
                      }
                      if (a.id < b.id) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              console.error("Error", error);
              this.loadingPacientes = false;
            })
            .finally(() => {
              this.loadingPacientes = false;
            });
        return this.listaPacientes;
      }
    },
    limpiarPacienteSeleccionado() {
      this.datosFormulario.idPaciente = null;
      this.datosFormulario.nombrePaciente = null;
      this.datosFormulario.nombrePacienteBusqueda = null;
      this.listaPacientes = Array();
    },

    async buscarAgenda(cerrarModal) {
        this.citasSinProcesar = Array();
        this.eventos = Array();
        this.horariosDoctor = [];
        this.listaEspecialidades = [
          {
            id: null,
            nombre: "Todos",
            color: "white",
          },
        ];

        const idClinica = this.datosBusqueda.clinica.clinicaID;
        if (idClinica === undefined || idClinica === null || idClinica === 0) {
          return;
        }

        this.loading = true;

        const clinicaID = this.datosBusqueda.clinica.clinicaID;
        const fechaInicio =
            this.$moment(this.datosBusqueda.fechaInicio)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
        const fechaFin =
            this.$moment(this.datosBusqueda.fechaFin)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");


        const parametros = {
          idClinica: clinicaID,
          fechaInicio: fechaInicio,
          fechaFin: fechaFin
        }
        
        this.$http
            .post(
                this.$api +
                "agenda/obtenerCitasAgenda", parametros
            )
            .then((response) => {
              if (response.status === 200 && response.data.data !== undefined) {
                this.listaCitas = response;
                this.procesarBusquedaAgenda(response);
              }
            })
            .catch((error) => {
              console.error("No hay datos" + error);
              this.loading = false;
              this.loadingCAl = false;
              this.showDetail = cerrarModal === false ? true : false;
            }).finally(() => {
              this.loadingCAl = false;
              this.showDetail = cerrarModal === false ? true : false;
            });

    },

    async procesarBusquedaAgenda(response) {
      this.eventos = [];
      await this.procesarCitasClinica(response);
      await this.procesarHorariosDoctorClinica(response);
      await this.procesarHorariosBloqueados(response);
      await this.llenarFiltros(response);
      this.loadingCAl = false;

      const refObj = this.semanalDiaria ? this.$refs.calDentaliaDiario : this.$refs.calDentaliaSemanal;

      if (refObj !== undefined) {
        await refObj.calcularSemana(
            this.datosBusqueda.fechaInicio,
            this.eventos,
            this.horariosDoctor,
            this.getNumeroSillonesClinica
        );
        this.obtenerSemana();
      }
      this.loading = false;
    },
    async procesarCitasClinica(response) {
      if (
          response.data.data.citas !== undefined &&
          response.data.data.citas !== null
      ) {
        response.data.data.citas.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();
          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          if (v.horaInicio.toString().length === 4) {
            v.horaInicioCasilla =
                v.horaInicio.substr(0, 2) + ":" + v.horaInicio.substr(2, 3);
          }
          if (v.horaFin.toString().length === 4) {
            v.horaFinCasilla =
                v.horaFin.substr(0, 2) + ":" + v.horaFin.substr(2, 3);
          }

          v.especialistaNino = false;
          if (
              v.idEspecialidadDoctor !== undefined &&
              v.idEspecialidadDoctor !== null
          ) {
            try {
              const especiDoc = v.idEspecialidadDoctor.split(",").map(Number);
              v.especialistaNino = especiDoc.indexOf(3) > -1;
            } catch (e) {
              console.error(e);
            }
          }

          const fechaEvento = this.$moment(v.fechaCitaSinZona).format(
              "YYYY/MM/DD"
          );
          v.fechaCita = this.$moment(v.fechaCitaSinZona);

          const sillon = v.sillon;

          v.titleDebug = "";
          if (this.$debug && v.idCita == 210000236) {
            v.titleDebug =
                "ID:" +
                v.idCita.idCita +
                " - estatus:" +
                v.idCita.idEstatusCita +
                v.idCita.notacionCanalOrigen +
                " " +
                (v.idCita.siglasAseguradora !== undefined &&
                v.idCita.siglasAseguradora !== null &&
                v.idCita.siglasAseguradora.length > 0
                    ? v.idCita.siglasAseguradora
                    : "") +
                " Pac: " +
                v.idCita.idPaciente +
                "-" +
                v.idCita.nombrePaciente +
                " Doc: " +
                v.idCita.idDoctor +
                "-" +
                v.idCita.nombreDoctor +
                " Sillón: " +
                v.idCita.sillon +
                " Fecha: " +
                this.$formatoFecha(v.idCita.fechaCita) +
                " Horario: " +
                this.$formatoHoraDeHora(v.idCita.horaInicioCasilla) +
                " a " +
                this.$formatoHoraDeHora(v.idCita.horaFinCasilla);
          }

          v.inicialesDoctor = this.$iniciales(v.nombreDoctor);

          v.mostrarSiglasAseguradora =
              v.siglasAseguradora !== undefined &&
              v.siglasAseguradora !== null &&
              v.siglasAseguradora.length > 0;

          if (v.motivoCitaTag !== undefined) {
            v.citaUrgencia = v.motivoCitaTag === "DOLOR/URGENCIA";
          }

          if (!this.semanalDiaria){
            v = this.calcularTamaniosColoresCita(v);
          }else{
            v = this.calcularTamaniosColoresCitaDiarias(v);
          }

          this.citasSinProcesar.push(v);

          let citaParaCasilla = JSON.parse(JSON.stringify(v));

          ////////encontrar cita en eventos procesados
          const pos = fechaEvento + "-" + v.horaInicio + "-" + sillon;
          let datosCasilla = this.eventos[pos];

          if (datosCasilla === undefined || datosCasilla == null) {
            let eventoEncontrado = undefined;
            for (let [, ev] of Object.entries(this.eventos)) {
              eventoEncontrado = ev.citas.find(evv => {
                return evv.fechaCitaSinZona == v.fechaCitaSinZona
                && Number(evv.horaInicio) < Number(v.horaFin)
                && Number(evv.horaFin) > Number(v.horaInicio)
                && evv.sillon == v.sillon
              });

              if (eventoEncontrado != undefined) {
                datosCasilla = ev;
                break;
              }
            }
          }

          ////////

          if (datosCasilla === undefined || datosCasilla === null) {
            datosCasilla = {
              style: citaParaCasilla.style,
              ancho: citaParaCasilla.ancho,
              tamanioN: citaParaCasilla.tamanioN,
              titleDebug: citaParaCasilla.titleDebug,
              colorEstatusSDI: citaParaCasilla.colorEstatusSDI,
              citaUrgencia: citaParaCasilla.citaUrgencia,
              notacionCanalOrigen: citaParaCasilla.notacionCanalOrigen,
              inicialesDoctor: citaParaCasilla.inicialesDoctor,
              lstImagenes: citaParaCasilla.lstImagenes,
              mostrarSiglasAseguradora:
              citaParaCasilla.mostrarSiglasAseguradora,
              siglasAseguradora: citaParaCasilla.siglasAseguradora,
              citas: [citaParaCasilla],
              citaSize: null,
            };

            this.eventos[pos] = datosCasilla;
          } else {
            datosCasilla.colorEstatusSDI = undefined; //quitamos el color del copete cuando hay mas citas
            datosCasilla.notacionCanalOrigen +=
                "/" + citaParaCasilla.notacionCanalOrigen;
            datosCasilla.inicialesDoctor +=
                "/" + citaParaCasilla.inicialesDoctor;
            datosCasilla.siglasAseguradora +=
                "/" + citaParaCasilla.siglasAseguradora;

            if (datosCasilla.lstImagenes === null) {
              datosCasilla.lstImagenes = [];
            }
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.concat(
                citaParaCasilla.lstImagenes
            );
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.filter(
                (valor, indice) => {
                  return datosCasilla.lstImagenes.indexOf(valor) === indice;
                }
            );

            datosCasilla.citaUrgencia =
                datosCasilla.citaUrgencia ||
                (!datosCasilla.citaUrgencia && citaParaCasilla.citaUrgencia);

            datosCasilla.mostrarSiglasAseguradora =
                datosCasilla.mostrarSiglasAseguradora ||
                (!datosCasilla.mostrarSiglasAseguradora &&
                    citaParaCasilla.mostrarSiglasAseguradora);

            datosCasilla.citas.push(citaParaCasilla);

            datosCasilla.citaSize = datosCasilla.citas.length;
            if (!this.semanalDiaria){
              datosCasilla = this.calcularTamaniosColoresCitaMulti(datosCasilla);
            }else{
              datosCasilla = this.calcularTamaniosColoresCitaMultiDiarias(datosCasilla);
            }

          }


        });
        return this.eventos;
      }
      return true;
    },
    calcularTamaniosColoresCita(cita) {
      cita.color = "background: rgb(255, 102, 0);";
      this.colorCita = "(255, 102, 0)";
      cita.tamanio = "height: 26.75px;";
      cita.tamanioN = 26.75;
      cita.border = "";

      const fc1 = new Date("2014-02-27T" + cita.horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + cita.horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      const tamanio = 26.75 * vecesRepetir;
      cita.tamanioN = tamanio;

      cita.tamanio = "height: " + tamanio + "px;";

      if (Number(cita.idEstatusCita) === 11) {
        cita.color = "background: rgb(208, 38, 38);";
        this.colorCita = "(208, 38, 38)";
      } else if (Number(cita.idEstatusCita) === 12) {
        cita.color = "background: rgb(52, 141, 0);";
        this.colorCita = "(208, 38, 38)";
      }

      if (cita.idMovimientoAgendable != null && Number(cita.idMovimientoAgendable) === 1) {
        cita.color = "background: rgb(247 244 242);";
        this.colorCita = "(255, 102, 0)";
        if (Number(cita.idEstatusCita) === 11) {
          cita.border = "border: solid 3px rgb(208, 38, 38);";
        } else if (Number(cita.idEstatusCita) === 12) {
          cita.border = "border: solid 3px rgb(52, 141, 0);";
        }else if (Number(cita.idEstatusCita) === 12) {
          cita.border = "border: solid 3px rgb(52, 141, 0);";
        }else if (Number(cita.idEstatusCita) === 5 || Number(cita.idEstatusCita) === 24) {
          cita.border = "border: solid 3px rgb(255, 102, 0);";
        }
      }else if (cita.idMovimientoAgendable != null && Number(cita.idMovimientoAgendable) === 2) {
        cita.border = "border: solid 1px #000";
        this.colorCita = "(86 199 234);"
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        cita.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        cita.ancho = "width:" + 20 / num + "px;";
      } else {
        cita.ancho = "width:" + 80 / num + "px; color:black;";
      }

      cita.style = cita.ancho + cita.color + cita.tamanio + cita.border;

      if (this.$debug) {
        cita.titleDebug =
            cita.titleDebug +
            "  Color:" +
            cita.color +
            "  Tamanio:" +
            cita.tamanio +
            "  Ancho:" +
            cita.ancho;
      }

      return cita;
    },

    calcularTamaniosColoresCitaDiarias(cita) {
      cita.color = "background: rgb(255, 102, 0);";
      this.colorCita = "(255, 102, 0)";
      cita.tamanio = "height: 26.75px;";
      cita.tamanioN = 26.75;

      const fc1 = new Date("2014-02-27T" + cita.horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + cita.horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      const tamanio = 26.75 * vecesRepetir;
      cita.tamanioN = tamanio;

      cita.tamanio = "height: " + tamanio + "px;";

      if (Number(cita.idEstatusCita) === 11) {
        cita.color = "background: rgb(208, 38, 38);";
        this.colorCita = "(208, 38, 38)";
      } else if (Number(cita.idEstatusCita) === 12) {
        cita.color = "background: rgb(52, 141, 0);";
        this.colorCita = "(208, 38, 38)";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {

        cita.ancho = "width:160px; margin-left: 16px;";
      } else if (this.getNumeroSillonesClinica <= 6) {

        cita.ancho = "width:" + 130 / num + "px; margin-left: 10px;";}
      else {

        cita.ancho = "width:" + 500 / num + "px; color:black; margin-left: 6px;";
      }

      cita.style = cita.ancho + cita.color + cita.tamanio;

      if (this.$debug) {
        cita.titleDebug =
            cita.titleDebug +
            "  Color:" +
            cita.color +
            "  Tamanio:" +
            cita.tamanio +
            "  Ancho:" +
            cita.ancho;
      }

      return cita;
    },

    calcularTamaniosColoresCitaMulti(datosCasilla) {
      let confirmados = 0;
      let asistidos = 0;
      let horaInicioCasilla = datosCasilla.citas[0].horaInicioCasilla;
      let horaFinCasilla = datosCasilla.citas[0].horaFinCasilla;
      datosCasilla.citas.forEach((it) => {
        if (it.horaInicioCasilla < horaInicioCasilla) {
          horaInicioCasilla = it.horaInicioCasilla;
        }

        if (it.horaFinCasilla > horaFinCasilla) {
          horaFinCasilla = it.horaFinCasilla;
        }

        if (Number(it.idEstatusCita) === 11) {
          confirmados++;
        } else if (Number(it.idEstatusCita) === 12) {
          asistidos++;
        }
      });

      const fc1 = new Date("2014-02-27T" + horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      datosCasilla.tamanioN = 26.75 * vecesRepetir;
      const tamanio = "height: " + datosCasilla.tamanioN + "px;";

      let color = "background:rgb(255 190 117);";
      let border = "border: solid 1px black;"

      if (confirmados === datosCasilla.citaSize) {
        color = "background: rgb(208, 38, 38);";
      } else if (asistidos === datosCasilla.citaSize) {
        color = "background: rgb(52, 141, 0);";
      } else if (confirmados > 0 && asistidos > 0) {
        color = "background: rgb(244, 142, 52);";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        datosCasilla.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        datosCasilla.ancho = "width:" + 20 / num + "px;";
      } else {
        datosCasilla.ancho = "width:" + 80 / num + "px; color:black;";
      }

      datosCasilla.style = datosCasilla.ancho + color + tamanio + border;

      if (this.$debug) {
        datosCasilla.titleDebug =
            "  Color:" +
            color +
            "  Tamanio:" +
            tamanio +
            "  Ancho:" +
            datosCasilla.ancho;
      }

      return datosCasilla;
    },

    calcularTamaniosColoresCitaMultiDiarias(datosCasilla) {
      let confirmados = 0;
      let asistidos = 0;
      let horaInicioCasilla = datosCasilla.citas[0].horaInicioCasilla;
      let horaFinCasilla = datosCasilla.citas[0].horaFinCasilla;
      datosCasilla.citas.forEach((it) => {
        if (it.horaInicioCasilla < horaInicioCasilla) {
          horaInicioCasilla = it.horaInicioCasilla;
        }

        if (it.horaFinCasilla > horaFinCasilla) {
          horaFinCasilla = it.horaFinCasilla;
        }

        if (Number(it.idEstatusCita) === 11) {
          confirmados++;
        } else if (Number(it.idEstatusCita) === 12) {
          asistidos++;
        }
      });

      const fc1 = new Date("2014-02-27T" + horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      datosCasilla.tamanioN = 26.75 * vecesRepetir;
      const tamanio = "height: " + datosCasilla.tamanioN + "px;";

      let color = "background:rgb(202, 225, 82);";
      if (confirmados === datosCasilla.citaSize) {
        color = "background: rgb(208, 38, 38);";
      } else if (asistidos === datosCasilla.citaSize) {
        color = "background: rgb(52, 141, 0);";
      } else if (confirmados > 0 && asistidos > 0) {
        color = "background: rgb(244, 142, 52);";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        datosCasilla.ancho = "width:160px; margin-left: 16px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        datosCasilla.ancho = "width:" + 400 / num + "px; margin-left: 10px;";}
      else {
        datosCasilla.ancho = "width:" + 500 / num + "px; color:black; margin-left: 6px;";
      }

      datosCasilla.style = datosCasilla.ancho + color + tamanio;

      if (this.$debug) {
        datosCasilla.titleDebug =
            "  Color:" +
            color +
            "  Tamanio:" +
            tamanio +
            "  Ancho:" +
            datosCasilla.ancho;
      }

      return datosCasilla;
    },

    async procesarHorariosDoctorClinica(response) {
      //---Inicio, se genera la lista de especialidades a partir del horario doctor
      //---Se genera el arreglo inicial de horarios de doctor por dia
      const listaEspTemp = Array();

      const fechaInicioBusq = this.$moment(this.datosBusqueda.fechaInicio);
      fechaInicioBusq.set({hour: 0, minute: 0, second: 0, millisecond: 0});

      const fechaFinBusq = this.$moment(this.datosBusqueda.fechaFin);
      fechaFinBusq.set({hour: 0, minute: 0, second: 0, millisecond: 0});

      const horaInicioActividades = 700;
      const horaFinActividades = 2359;

      if (
          response.data.data.horariosDoctor !== undefined &&
          response.data.data.horariosDoctor !== null
      ) {
        response.data.data.horariosDoctor.forEach((hd) => {
          hd.horaInicio = hd.horaInicio.toString();
          if (hd.horaInicio.length < 4) {
            hd.horaInicio = "0" + hd.horaInicio;
          }

          hd.horaFin = hd.horaFin.toString();
          if (hd.horaFin.length < 4) {
            hd.horaFin = "0" + hd.horaFin;
          }

          if (hd.horaInicio.toString().length === 4) {
            hd.horaInicioCasilla =
                hd.horaInicio.substr(0, 2) + ":" + hd.horaInicio.substr(2, 3);
          }
          if (hd.horaFin.toString().length === 4) {
            hd.horaFinCasilla =
                hd.horaFin.substr(0, 2) + ":" + hd.horaFin.substr(2, 3);
          }

          const fechaInicioEvento = this.$moment(new Date(hd.fechaInicio));
          fechaInicioEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          const fechaFinEvento = this.$moment(new Date(hd.fechaFin));
          fechaFinEvento.set({hour: 0, minute: 0, second: 0, millisecond: 0});

          const pos =
              fechaInicioEvento.format("YYYY/MM/DD") +
              "-" +
              hd.horaInicio +
              "-" +
              hd.sillon;
          const obj = {
            idAgendaEmpleado: hd.idAgendaEmpleado,
            sillon: hd.sillon,
            idEmpleado: hd.idEmpleado,
            nombreEmpleado: hd.nombreEmpleado,
            colorEspecialidad: hd.colorEspecialidad + "4D",
            idEspecialidad: hd.idEspecialidad,
            nombreEspecialidad: hd.nombreEspecialidad,
            periodicidad: hd.periodicidad,
            fechaInicio: fechaInicioEvento,
            fechaFin: fechaFinEvento,
            horaInicio: hd.horaInicio,
            horaFin: hd.horaFin,
            horaInicioCasilla: hd.horaInicioCasilla,
            horaFinCasilla: hd.horaFinCasilla,
            idBloque: hd.idBloque
          };

          if (
              fechaInicioEvento >= fechaInicioBusq &&
              fechaInicioEvento <= fechaFinBusq &&
              Number(obj.horaInicio) >= horaInicioActividades &&
              Number(obj.horaInicio) <= horaFinActividades
          ) {
            listaEspTemp[hd.idEspecialidad] = {
              id: hd.idEspecialidad,
              nombre: hd.nombreEspecialidad,
              color: hd.colorEspecialidad,
            };
          }

          this.horariosDoctor[pos] = obj;

          const horaInicioOriginal = this.$moment(
              "01/01/2020 " + obj.horaInicioCasilla
          );
          const horaFinOriginal = this.$moment(
              "01/01/2020 " + obj.horaFinCasilla
          );

          let nuevaHora = horaInicioOriginal.clone();
          while (nuevaHora < horaFinOriginal) {
            const posOrg =
                fechaInicioEvento.format("YYYY/MM/DD") +
                "-" +
                nuevaHora.format("HHmm") +
                "-" +
                hd.sillon;

            const nuevoHorario = JSON.parse(JSON.stringify(obj));
            nuevoHorario.horaInicio = nuevaHora.clone().format("HHmm");

            if (
                nuevoHorario.periodicidad !== undefined &&
                nuevoHorario.periodicidad === 5
            ) {
              this.horariosDoctor[posOrg] = nuevoHorario;
            } else {
              this.horariosDoctor[posOrg] = nuevoHorario;
            }

            nuevaHora = nuevaHora.add(15, "minutes");
          }
        });

        const horariosDoctorTemp = [];

        for (const hdOrigen in this.horariosDoctor) {
          const hd = this.horariosDoctor[hdOrigen];

          if (hd.horaInicio !== undefined) {
            const fechaInicioOriginal = this.$moment(hd.fechaInicio);
            const fechaFinOriginal = this.$moment(hd.fechaFin);

            let nuevaFecha = fechaInicioOriginal;
            while (nuevaFecha < fechaFinOriginal) {
              if (hd.periodicidad === 5) {
                //periodicidad unica
                break;
              }

              if (hd.periodicidad === 1) {
                nuevaFecha = nuevaFecha.add(1, "weeks");
              } else if (hd.periodicidad === 2) {
                nuevaFecha = nuevaFecha.add(2, "weeks");
              } else if (hd.periodicidad === 3) {
                nuevaFecha = nuevaFecha.add(1, "months");
              } else {
                nuevaFecha = nuevaFecha.add(1, "days");
              }

              const posOrg =
                  nuevaFecha.format("YYYY/MM/DD") +
                  "-" +
                  hd.horaInicio +
                  "-" +
                  hd.sillon;
              hd.fechaInicio = nuevaFecha.clone();

              if (
                  nuevaFecha >= fechaInicioBusq &&
                  nuevaFecha <= fechaFinBusq &&
                  Number(hd.horaInicio) >= horaInicioActividades &&
                  Number(hd.horaInicio) <= horaFinActividades
              ) {
                horariosDoctorTemp[posOrg] = hd;
                listaEspTemp[hd.idEspecialidad] = {
                  id: hd.idEspecialidad,
                  nombre: hd.nombreEspecialidad,
                  color: hd.colorEspecialidad,
                };
              }
            }
          }
        }

        for (const hdTempin in horariosDoctorTemp) {
          const hdTemp = horariosDoctorTemp[hdTempin];

          if (hdTemp.horaInicio !== undefined) {
            this.horariosDoctor[hdTempin] = hdTemp;
          }
        }

        listaEspTemp.forEach((l) => {
          this.listaEspecialidades.push(l);
        });
      }
      return true;
    },
    async procesarHorariosBloqueados(response) {
      if (
          response.data.data.horariosBloqueados !== undefined &&
          response.data.data.horariosBloqueados !== null
      ) {
        response.data.data.horariosBloqueados.forEach((hb) => {
          hb.horaInicio = hb.horaInicio.toString();
          if (hb.horaInicio.length < 4) {
            hb.horaInicio = "0" + hb.horaInicio;
          }

          hb.horaFin = hb.horaFin.toString();
          if (hb.horaFin.length < 4) {
            hb.horaFin = "0" + hb.horaFin;
          }

          if (hb.horaInicio.toString().length === 4) {
            hb.horaInicioCasilla =
                hb.horaInicio.substr(0, 2) + ":" + hb.horaInicio.substr(2, 3);
          }
          if (hb.horaFin.toString().length === 4) {
            hb.horaFinCasilla =
                hb.horaFin.substr(0, 2) + ":" + hb.horaFin.substr(2, 3);
          }

          let fechaInicioHBEvento = this.$moment(new Date(hb.fechaInicio));
          fechaInicioHBEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          const fechaFinHBEvento = this.$moment(new Date(hb.fechaFin));
          fechaFinHBEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          while (fechaInicioHBEvento <= fechaFinHBEvento) {
            const horaInicioOriginal = this.$moment(
                "01/01/2020 " + hb.horaInicioCasilla
            );
            const horaFinOriginal = this.$moment(
                "01/01/2020 " + hb.horaFinCasilla
            );

            let nuevaHora = horaInicioOriginal.clone();
            while (nuevaHora < horaFinOriginal) {
              const posOrg =
                  fechaInicioHBEvento.format("YYYY/MM/DD") +
                  "-" +
                  nuevaHora.format("HHmm") +
                  "-" +
                  hb.sillon;
              delete this.horariosDoctor[posOrg];
              nuevaHora = nuevaHora.add(15, "minutes");
            }

            fechaInicioHBEvento.add(1, "days");
          }
        });
      }
      return true;
    },

    buscarHorariosClinica() {
      const idClinica = this.datosBusqueda.clinica.clinicaID;
      if (
          idClinica === undefined ||
          idClinica === null ||
          idClinica === 0 ||
          this.datosFormulario === undefined ||
          this.datosFormulario.fechaCita === undefined
      ) {
        return;
      }

      this.loadingHorariosClinica = true;

      

      let fechaInicio = null;
      try {
        fechaInicio =
            this.$moment(this.datosFormulario.fechaCita)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      } catch (e) {
        fechaInicio =
            this.datosFormulario.fechaCita
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      }

      const parametros = {
        idClinica: this.datosBusqueda.clinica.clinicaID,
        fechaInicio: fechaInicio
      }
      this.$http
          .post(
              this.$api +
              "agenda/obtenerHorariosClinicaParaAgenda", parametros
          )
          .then((response) => {
            if (response.status === 200 && response.data.data !== undefined) {
              this.procesarHorariosClinica(response)
                  .then(() => {
                    const refObj = this.semanalDiaria ? this.$refs.calDentaliaDiario : this.$refs.calDentaliaSemanal;
                    if (refObj !== undefined) {
                      refObj.calcularSemana(
                          this.datosBusqueda.fechaInicio,
                          this.eventos,
                          this.horariosDoctor,
                          this.getNumeroSillonesClinica
                      );
                      this.obtenerSemana();
                    }
                    this.loadingHorariosClinica = false;
                  })
                  .catch((e) => {
                    this.loadingHorariosClinica = false;
                    console.error(e);
                  });
            }
          })
          .catch((error) => {
            console.error("No hay datos" + error);
            this.loadingHorariosClinica = false;
          });
    },
    async procesarHorariosClinica(response) {
      this.horariosClinica = [];
      if (response.data.data !== undefined && response.data.data !== null) {
        response.data.data.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();

          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          const fechaEvento = this.$moment(v.fecha).utc().format("YYYY/MM/DD");
          const pos = fechaEvento + "-" + v.sillon;

          const horaIn = v.horaInicio.substr(0, 2);
          const horaFn = v.horaFin.substr(0, 2);
          const minIn = v.horaInicio.substr(2, 3);
          const minFn = v.horaFin.substr(2, 3);

          if (this.horariosClinica[pos] === undefined) {
            this.horariosClinica[pos] = {
              original: [],
              horas: [],
              horasMinutosDate: [],
            };
          }

          this.horariosClinica[pos].original.push(
              horaIn + ":" + minIn + " a " + horaFn + ":" + minFn
          );
          this.horariosClinica[pos].horas.push([
            Number(horaIn),
            Number(horaFn),
          ]);
          this.horariosClinica[pos].horasMinutosDate.push({
            horaInicio: this.$moment(
                fechaEvento + " " + horaIn + ":" + minIn + ":00"
            ),
            horaFin: this.$moment(
                fechaEvento + " " + horaFn + ":" + minFn + ":00"
            ),
          });
        });
      }
      return true;
    },

    actualizarNombreClinica(inicializar) {
      const clinicaSelec = this.listaClinicas.find(
          (it) => it.id === this.datosBusqueda.clinica.clinicaID
      );
      if (clinicaSelec == null) {
        this.$swal.fire({
          icon: "error",
          title: "La clínica acaba de ser desactivada, recargando...",
          timer: 10000,
        });
        setTimeout(() => location.reload(), 3000);
      }
      if (clinicaSelec !== undefined && clinicaSelec !== null) {
        this.datosBusqueda.clinica.nombre = clinicaSelec.nombre;

        if (inicializar) {
          const fechaActual = new Date();
          this.seleccionarFecha(fechaActual, true);
        } else {
          this.borrarFiltros();
          this.buscarAgenda();
        }

        this.llenarPacientesClinica();
      }
    },
    seleccionarFechaCalendario() {

      this.seleccionarFecha(this.datosBusqueda.fechaActual, true);
    },
    seleccionarFechaPorDiaSemana(date) {
      this.datosBusqueda.fechaInicio = date;

      this.datosBusqueda.fechaFin = new Date(this.datosBusqueda.fechaInicio);

      const numeroDias = this.semanalDiaria ? 1 : 7;

      this.datosBusqueda.fechaFin.setDate(
          this.datosBusqueda.fechaFin.getDate() + numeroDias
      );


      this.buscarAgenda();
    },
    seleccionarFecha(date, seleccionDirecta, registroCita) {
      const fecha = new Date(date.toISOString());
      fecha.setHours(0);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);

      this.datosBusqueda.fechaInicio = new Date(fecha.toISOString());
      this.datosBusqueda.fechaFin = new Date(fecha.toISOString());


      if (!this.semanalDiaria) {
        if (fecha.getDay() === 6) {
          //si es domingo
          this.datosBusqueda.fechaInicio.setDate(fecha.getDate() + 1);
          this.datosBusqueda.fechaFin.setDate(fecha.getDate() + 7);
        } else {
          this.datosBusqueda.fechaInicio.setDate(
              fecha.getDate() - fecha.getDay()
          );
          this.datosBusqueda.fechaFin.setDate(
              fecha.getDate() + (7 - date.getDay())
          );
        }
      }else if (registroCita){
        this.datosBusqueda.fechaInicio.setDate(fecha.getDate() + 1);
        this.datosBusqueda.fechaFin.setDate(fecha.getDate() + 1);
      }

      if (!seleccionDirecta && !this.semanalDiaria) {
          const semanaFechaIn = this.$moment(this.datosBusqueda.fechaFin.toISOString()).week()
          const numeroSemanaFechaHOY = this.$moment().week();
          if (semanaFechaIn === numeroSemanaFechaHOY) {
            this.datosBusqueda.fechaActual = new Date();
          } else {
            this.datosBusqueda.fechaActual = new Date(this.datosBusqueda.fechaInicio.toISOString());
          }
      }

      if (!seleccionDirecta && this.semanalDiaria) {
        this.datosBusqueda.fechaActual = new Date(this.datosBusqueda.fechaInicio.toISOString());
      }

      this.buscarAgenda();
    },
    saveEvent() {
      if (!this.rangoHoraFormEsValido && !this.citaIsOverbooking) {
        this.$swal.fire({
          icon: "error",
          title: "Selecciona un horario válido para poder continuar",
        });
        return;
      }

      if (
          this.datosFormulario.idPaciente === undefined ||
          this.datosFormulario.idPaciente == null ||
          this.datosFormulario.idPaciente === 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes buscar y seleccionar un paciente",
        });
        return;
      }

      this.loading = true;

      const datosGuardar = JSON.parse(JSON.stringify(this.datosFormulario));
      var fechaCita = "";
      if (this.citaIsOverbooking) {
        fechaCita = this.$moment(datosGuardar.fechaSinZona).format(
            "YYYY-MM-DD"
        );
      } else {
        fechaCita = this.$moment(datosGuardar.fechaCita).format("YYYY-MM-DD");
      }

      const horaCita = this.$moment(fechaCita);

      datosGuardar.fechaCita = this.$moment(horaCita)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      datosGuardar.horaInicio =
          datosGuardar.horaInicio.HH + "" + datosGuardar.horaInicio.mm;
      datosGuardar.horaFin =
          datosGuardar.horaFin.HH + "" + datosGuardar.horaFin.mm;
      datosGuardar.idClinica = this.datosBusqueda.clinica.clinicaID;
      datosGuardar.citaAdministrativa = this.citaAdministrativa;

      if (
          datosGuardar.sillon === undefined ||
          datosGuardar.sillon === null ||
          datosGuardar.sillon <= 0
      ) {
        datosGuardar.sillon = 1;
      }

      if (this.secondReagendar) {
        this.submitReagendarCita(datosGuardar);
      } else {
        this.$http
            .post(this.$api + "agenda/registrarCita", datosGuardar)
            .then((response) => {
              if (response.status === 200) {
                this.$swal.fire({
                  icon: "success",
                  title: "La cita se registró con éxito",
                });
                this.second = false;
                this.busquedaOverbooking = false;
                this.citaIsOverbooking = false;
                this.modSobreAsignarDoctor = false;
                this.citaAdministrativa = false;

                this.seleccionarFecha(new Date(fechaCita), true, true);
              }
            })
            .catch((error) => {
              console.error(error);
              if (error.response) {
                let mensaje = error.response.data.message;
                console.error(mensaje);
                try {
                  if (error.response.data.data !== undefined) {
                    mensaje +=
                        " (Fecha bloqueo del " +
                        this.$formatoFecha(
                            error.response.data.data.fechaInicioBloqueo
                        ) +
                        " al " +
                        this.$formatoFecha(
                            error.response.data.data.fechaFinBloqueo
                        ) +
                        " de " +
                        this.$formatoHora(
                            error.response.data.data.horaInicioBloqueo
                        ) +
                        " a " +
                        this.$formatoHora(error.response.data.data.horaFinBloqueo) +
                        ")";
                  }
                } catch (e) {
                  console.error(e);
                }

                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "Horario ocupado",
                });
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
                });
              }
            })
            .finally(() => (this.loading = false));
      }
    },
    submitAgregarAgenda() {
      this.$refs.submitAgregarAgenda.click();

    },
    consultarDetallePorPaciente() {
      this.datosDetalle = this.datosDetalleOriginal[0];
      this.datosDetalleOverbooking = null;
      if (this.datosDetalleOriginal.length > 1) {
        this.datosDetalleOverbooking = this.datosDetalleOriginal[1];
      }
    },
    initDatosCitaNueva() {
      this.datosFormulario = {
        nombrePacienteBusqueda: null,
        idPaciente: null,
        idDoctor: null,
        idConfianza: null,
        sillon: 1,
        fechaCita: new Date(),
        fechaCitaPerdida: null,
        horaInicio: {
          HH: "08",
          mm: "00",
        },
        horaFin: {
          HH: "08",
          mm: "00",
        },
        comentario: null,
        idCompania: 1,
        idClinica: null,
        idCanalOrigen: 1,
        idEspecialidad: null,
        idTratamiento: null,
        idTagMotivoCita: null,
      };
      this.tagMotivoCita();
    },
    crearCitaDesdeCalendario(datosAgregar) {
      this.initDatosCitaNueva();

      if (datosAgregar.sillon >= 100) {
        if (!this.$localStorageService.can("CA_06_crear_cita_embajador")) {
          return;
        }

        this.datosFormulario.citaEmbajador = true;
      }

      if (datosAgregar.sillon !== undefined && datosAgregar.sillon !== null) {
        this.datosFormulario.sillon = datosAgregar.sillon;
      }

      if (
          datosAgregar.idEspecialidad !== undefined &&
          datosAgregar.idEspecialidad !== null
      ) {
        this.datosFormulario.idEspecialidad = datosAgregar.idEspecialidad;
      }

      if (
          datosAgregar.idEmpleado !== undefined &&
          datosAgregar.idEmpleado !== null
      ) {
        this.datosFormulario.idDoctor = datosAgregar.idEmpleado;
      }

      if (
          datosAgregar.fechaCita !== undefined &&
          datosAgregar.fechaCita !== null
      ) {
        this.datosFormulario.fechaCita = datosAgregar.fechaCita;
      }

      if (datosAgregar.hora !== undefined && datosAgregar.hora !== null) {
        this.datosFormulario.horaInicio = {
          HH: datosAgregar.hora,
          mm: datosAgregar.minuto,
        };
        this.datosFormulario.horaFin = {
          HH: datosAgregar.hora,
          mm: "59",
        };
      }

      this.listaPacientes = Array();
      this.secondCitaDesdeCalendario = true;
      this.secondReagendar = false;
      this.second = true;

      this.buscarHorariosClinica();
      this.llenarEspecialidadesDoctor(false);
      this.llenarDoctoresClinica(this.datosBusqueda.clinica.clinicaID);
    },

    mostrarModalCrearCita(citaEmbajador) {
      if (
          this.datosBusqueda.idEspecialidad !== undefined &&
          this.datosBusqueda.idEspecialidad !== null
      ) {
        this.datosFormulario.idEspecialidad = this.datosBusqueda.idEspecialidad;
      }

      if (
          this.datosBusqueda.empleadoId !== undefined &&
          this.datosBusqueda.empleadoId !== null
      ) {
        this.datosFormulario.idDoctor = this.datosBusqueda.clinica.empleadoId;
      }

      this.secondCitaDesdeCalendario = false;
      this.secondReagendar = false;
      if (citaEmbajador) {
        this.second = true;
      }
      this.initDatosCitaNueva();

      this.llenarEspecialidadesDoctor(false);

      this.listaPacientes = Array();

      this.datosFormulario.citaEmbajador = citaEmbajador;

      if (citaEmbajador) {
        this.datosFormulario.sillon = 100;
      } else {
        this.datosFormulario.sillon = 1;
      }

      const idClinica = this.datosBusqueda.clinica.clinicaID;

      this.buscarHorariosClinica();
      if (citaEmbajador) {
        this.llenarDoctoresEmbajadorClinica(idClinica);
      } else {
        this.llenarDoctoresClinica(idClinica);
      }
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    setearPaciente(item) {
      this.datosFormulario.idPaciente = item.id;
      this.datosFormulario.nombrePaciente = item.name;
      this.datosFormulario.esPacienteNuevo = item.esPacienteNuevo;
      this.datosFormulario.indicadorProbabilidad = item.indicadorProbabilidad;
      this.datosFormulario.telefono = item.telefono;
      this.datosFormulario.correo = item.correo;
      this.datosFormulario.esPacienteVIP = item.esPacienteVIP;

      this.idTagMotivoCita = undefined;
      this.datosFormulario.idTratamiento = undefined;
      this.datosFormulario.nombreTratamiento =
          "--Primero selecciona un motivo--";

      window.scrollTo(0, 0);
      this.tagMotivoCita();
    },
    setearMotivoTag(item) {
      if (this.datosFormulario.esPacienteNuevo) {
        const datos = JSON.parse(JSON.stringify(this.tagmotivocitaDatosArray));
        const tratamientos = datos.filter((it) => it.idTagMotivoCita === item);
        if (tratamientos !== undefined && tratamientos[0] !== undefined) {
          this.datosFormulario.idTratamiento = tratamientos[0].idTratamiento;
          this.datosFormulario.nombreTratamiento =
              tratamientos[0].nombreTratamiento.toUpperCase();
        }
      }
    },
    obtenerEspecialidadesDoctor(doctor) {
      if (
          doctor.especialidades != undefined &&
          doctor.especialidades !== null
      ) {
        return doctor.especialidades
            .map((esp) => esp.nombreEspecialidad)
            .join(", ");
      } else {
        return "-";
      }
    },
    tagMotivoCita() {
      this.tagmotivocitaDatosArray = [];

      if (
          this.datosFormulario !== undefined &&
          this.datosFormulario !== null &&
          this.datosFormulario.idPaciente !== undefined &&
          this.datosFormulario.idPaciente !== null
      ) {
        const parametros = {idPaciente: this.datosFormulario.idPaciente}
        this.$http
            .post(
                this.$api +
                "tagmotivocita/tagmotivocita/paciente", parametros
            )
            .then((response) => {
              this.tagmotivocitaDatosArray = response.data.data;
              this.tagmotivocitaDatosArrayFiltro = this.tagmotivocitaDatosArray;
              this.listaDoctores = [];
              if (this.datosFormulario.citaEmbajador) {
                this.llenarDoctoresEmbajadorClinica(
                    this.datosBusqueda.clinica.clinicaID
                );
              } else {
                this.llenarDoctoresEspecialistasClinica(
                    this.datosBusqueda.clinica.clinicaID
                );
              }
            });
      }
    },
    mostrarDetalle(cita) {
      this.showDetail = true;
      this.datosDetalleOriginal = cita.citas;
      this.pacienteSeleccionado = this.datosDetalleOriginal[0];
      this.fechaLlegada = this.pacienteSeleccionado.fechaLlegada;

      this.datosDetalleOriginal.forEach((element) => {
        element.isCitaConfirmada =
            element.estatusCita == "CONFIRMADA" ? true : false;
        let color = element.color.replace(/background: rgb/g, "");
        let colorSombrero = element.colorEstatusSDI;
        let sinComa = color.replace(/;/g, "");
        element.colorCitaOverbooking =
            "border-color: " +
            " rgb" +
            sinComa +
            " rgb" +
            sinComa +
            " rgb" +
            sinComa +
            colorSombrero +
            ";border-width:3px 3px 3px 17px;width: 70%; height: 20%; margin:2%;box-shadow: 0px 4px 26px -11px rgba(0,0,0,0.59);border-radius: 10px;border-style: solid;";
      });
    },
    buscarDoctoresEnFiltros() {
      this.filtros.options.doctores.forEach(it=>{

        if (this.filtros.selects.nombreDoctor !== undefined && this.filtros.selects.nombreDoctor !== null
        && this.filtros.selects.nombreDoctor !== '') {
          it.visible = false;

          if (it.titulo.toUpperCase().includes(this.filtros.selects.nombreDoctor.toUpperCase())) {
            it.visible = true;
          }
        } else {
          it.visible = true;
        }
      });
    },
    tieneFiltros() {
      const tieneFiltros =
          (this.filtros.selects.montoPti[0] !== 0 || this.filtros.selects.montoPti[1] !== 200000) ||
          (this.filtros.selects.porcentajeConfianza[0] !== 0 || this.filtros.selects.porcentajeConfianza[1] !== 100) ||
          this.filtros.selects.motivosCita.length > 0 ||
          this.filtros.selects.canalCita.length > 0 ||
        this.filtros.selects.estatusCita.length > 0 ||
        this.filtros.selects.especialidades.length > 0 ||
        this.filtros.selects.pacienteNatural ||
          this.filtros.selects.pacientePlan ||
        this.filtros.selects.planes.length > 0 ||
        this.filtros.selects.tipos.length > 0 ||
        this.filtros.selects.doctores.length > 0 ||
        this.filtros.selects.sillones.length > 0;

      return tieneFiltros;
    },
    borrarFiltros() {
      this.valorInicialMontoPti = 0;
      this.valorFinalMontoPti = 200000;
      this.filtros.selects = {
        porcentajeConfianza: [0, 100],
        canalCita: [],
        montoPti: [0, 200000],
        motivosCita: [],
        estatusCita: [],
        especialidades: [],
        pacienteNatural: false,
        pacientePlan: false,
        planes: [],
        tipos: [],
        nombreDoctor: "",
        doctores: [],
        sillones: []
      }
    },
    llenarFiltros() {
        const response = this.listaCitas;
      if (response.data.data.planes !== undefined && response.data.data.planes !== null) {
        response.data.data.planes.forEach(p => {
          if (this.filtros.options.planes.findIndex(p0 => p0.id === p.idPlan) === -1) {
            this.filtros.options.planes.push({
              titulo: p.nombrePlan,
              id: p.idPlan,
              img: p.logo,
            });
          }
        });
      }


      this.filtros.options.tipos = [
        {titulo:"Primera Vez", id:1, color:"#white"},
        {titulo:"Frecuente", id:2, color:"#00aa33"},
        {titulo:"Dormido", id:3, color:"#743232"}
      ];

      if (this.filtros.options.sillones.length===0) {
        for (let i=1 ; i <= this.getNumeroSillonesClinica; i++) {
          this.filtros.options.sillones.push({
            titulo: "Sillón " + i,
            id: i
          });
        }
        this.filtros.options.sillones.push({titulo: "Sillón E1", id: 100});
        this.filtros.options.sillones.push({titulo: "Sillón E2", id: 101});
      }


      // eslint-disable-next-line no-unused-vars
      for (const [k, v] of Object.entries(this.horariosDoctor)) { //const [k, v]

        if (v.idEspecialidad !== undefined && v.idEspecialidad !== null
            && this.filtros.options.especialidades.findIndex(x => Number(x.id) === Number(v.idEspecialidad)) === -1) {
          this.filtros.options.especialidades.push({
            titulo: v.nombreEspecialidad,
            id: v.idEspecialidad,
            color: v.colorEspecialidad
          });
        }

        if (v.idEmpleado !== undefined && v.idEmpleado !== null
            && this.filtros.options.doctores.findIndex(x => x.id === v.idEmpleado) === -1) {
          this.filtros.options.doctores.push({
            titulo: v.nombreEmpleado,
            id: v.idEmpleado,
            visible: true
          });
        }

      }

      // eslint-disable-next-line no-unused-vars
      for (const [k, v] of Object.entries(this.eventos)) { //const [k, v]
        v.citas.forEach(c => {

          if (this.filtros.options.motivosCita.findIndex(x => x.id === c.motivoCitaTag) === -1) {
            this.filtros.options.motivosCita.push({
              titulo: c.motivoCitaTag,
              id: c.motivoCitaTag,
            });
          }
          if (this.filtros.options.canalCita.findIndex(x => x.id === c.idCanalOrigen) === -1) {
            this.filtros.options.canalCita.push({
              titulo: c.canalOrigen,
              id: c.idCanalOrigen,
            });
          }

          if (this.filtros.options.estatusCita.findIndex(x => x.id === c.idEstatusCita) === -1) {
            this.filtros.options.estatusCita.push({
              titulo: c.estatusCita,
              id: c.idEstatusCita,
              color: c.color
            });
          }


          if (c.idEspecialidadDoctor !== null && c.idEspecialidadDoctor !== '') {
            const idsEsp = c.idEspecialidadDoctor.split(',');
            const nomEsp = c.nombreEspecialidadDoctor.split(',');

            for(let i = 0; i<idsEsp.length; i++) {
              if (this.filtros.options.especialidades.findIndex(x => Number(x.id) === Number(idsEsp[i])) === -1) {
                this.filtros.options.especialidades.push({
                  titulo: nomEsp[i],
                  id: idsEsp[i],
                  color: null
                });
              }
            }
          }

          if (this.filtros.options.doctores.findIndex(x => x.id === c.idDoctor) === -1) {
            this.filtros.options.doctores.push({
              titulo: c.nombreDoctor,
              id: c.idDoctor,
              visible: true
            });
          }

        });

      }

      this.ordenarFiltros(this.filtros.options.motivosCita);
      this.ordenarFiltros(this.filtros.options.canalCita);
      this.ordenarFiltros(this.filtros.options.estatusCita);
      this.ordenarFiltros(this.filtros.options.especialidades);
      this.ordenarFiltros(this.filtros.options.planes);
      this.ordenarFiltros(this.filtros.options.doctores);
      this.ordenarFiltros(this.filtros.options.tipos);
      
    },

    ordenarFiltros(filtro) {
      if (filtro !== undefined) {
        filtro.sort((a, b) => {
          let fa = a.titulo !== undefined && a.titulo !== null ? a.titulo.toLowerCase():"",
              fb = b.titulo !== undefined && b.titulo !== null ? b.titulo.toLowerCase():"";

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }
    },

    obtenerImagenPlan(idPlan) {
      const planImg = this.filtros.options.planes.find(it=>it.id===idPlan);

      if (planImg !== undefined && planImg !== null) {
        return planImg;
      }
      return null;
    },

    activarBarraLateral() {
      this.mostrarBarraLateral = !this.mostrarBarraLateral;
      this.mostrarBarraLateralCitas = this.mostrarBarraLateral;
    },

    async activarMenuDesdeProxCita(event, c) {
      const nuevaCita = JSON.parse(JSON.stringify(c));
      this.datosDetalleOriginal = [nuevaCita];
      this.pacienteSeleccionado = nuevaCita;
      this.$refs.menu.open(event);
    },

    seleccionarTodosLosPlanes() {
      this.filtros.selects.todosPlanes  = this.filtros.selects.planes.length !== this.filtros.options.planes.length;
      this.filtros.selects.planes = [];

      if (this.filtros.selects.todosPlanes) {
        if (this.filtros.options.planes !== null && this.filtros.options.planes !== undefined) {
          this.filtros.options.planes.forEach(it=>{
              this.filtros.selects.planes.push(it.id);
          });
        }
      }
    },
    seleccionarPlan() {
      this.filtros.selects.todosPlanes =
          this.filtros.selects.planes.length === this.filtros.options.planes.length
    },
    limpiarSeleccionPlan() {
      this.filtros.selects.planes = [];
      this.filtros.selects.todosPlanes = false;
    },




    mostrarModalCrearCitaDesdeCalendarioV2(datosAgregar) {
      if (datosAgregar.sillon >= 100 && !this.$localStorageService.can("CA_06_crear_cita_embajador")) {
       return;
      }

      this.datosPreCita = {
        sillon: datosAgregar.sillon,
        idEspecialidad: datosAgregar.idEspecialidad,
        idEmpleado: datosAgregar.idEmpleado,
        fechaCita: datosAgregar.fechaCita,
        citaDesdeCal: true,
        horaInicio: {
          HH: datosAgregar.hora,
          mm: datosAgregar.minuto
        }
      };

      this.datosDeCitaCalendario = datosAgregar;

      this.modalNuevaCita = true;
    },

    mostrarModalCrearCitaV2(citaEmbajador) {

      if (!this.$localStorageService.can("CA_06_crear_cita_embajador")) {
        return;
      }

      this.datosPreCita={};
      if (
          this.datosBusqueda.idEspecialidad !== undefined &&
          this.datosBusqueda.idEspecialidad !== null
      ) {
        this.datosPreCita.idEspecialidad = this.datosBusqueda.idEspecialidad;
      }

      if (
          this.datosBusqueda.empleadoId !== undefined &&
          this.datosBusqueda.empleadoId !== null
      ) {
        this.datosPreCita.idDoctor = this.datosBusqueda.clinica.empleadoId;
      }

      this.datosPreCita.citaEmbajador = citaEmbajador;

      this.modalNuevaCita = true;
    },

    async reagendarCita(datosAgregar) {

      let tratamientosCita = null;
      this.loading = true;
      const parametros = {idCita: this.datosDetalle.idCita}
      await this.$http
          .post(
              this.$api +
              "agenda/obtenerTratamientosCita", parametros
          ).then((response) => {
            tratamientosCita = response.data.data;
      }).finally(()=> {
        this.loading = false;
      })

      if (tratamientosCita == null || tratamientosCita.length === 0) {
        tratamientosCita = datosAgregar.tratamientos;
      }

      this.datosPreCita = {
        idCita: datosAgregar.idCita,
        idPaciente: datosAgregar.idPaciente,
        sillon: datosAgregar.sillon,
        idEspecialidad: datosAgregar.idEspecialidad,
        idEmpleado: datosAgregar.idDoctor,
        fechaCita: datosAgregar.fechaCita,
        idTagMotivoCita: datosAgregar.idTagMotivoCita,
        horaInicio: {
          HH: datosAgregar.horaInicio.substring(0, 2),
          mm: datosAgregar.horaInicio.substring(3, 5)
        },
        tratamientos: tratamientosCita,
        comentario: datosAgregar.comentario,
        comentarioFijo: datosAgregar.comentarioFijo,
        citaAdministrativa: datosAgregar.citaAdministrativa,

        citaReagendar: true,
        citaDesdeCal: false,
        citaEdicion: true,
        citaSobreAgendar: false
      };

      this.modalNuevaCita = true;
    },

    guardarNuevaCitaV2(datosActualizacion) {
      this.cerrarModalNuevaCitaV2();
      this.seleccionarFecha(datosActualizacion.fecha,
          datosActualizacion.seleccionDirecta, datosActualizacion.registroCita)

    },

    cerrarModalNuevaCitaV2() {
      this.datosDeCitaCalendario = null;
      this.modalNuevaCita=false;
    },

      async sobreAgendar(cita) {

      let valido = true;
      this.msgValidacion = "<ul class='validacioneslist'>";


        if (cita.idEstatusCita != 5 && cita.idEstatusCita != 24) {
          valido = false;
          this.msgValidacion += "<li>La cita debe estar en estatus normal ó reagendada</li>";
        }

        let tratamientosCita = null;
        this.loading = true;
        const parametros = {idCita: cita.idCita}
        await this.$http
            .post(
                this.$api +
                "agenda/obtenerTratamientosCita", parametros
            ).then((response) => {
              tratamientosCita = response.data.data;
            }).finally(() => {
              this.loading = false;
            })
        if (tratamientosCita == null || tratamientosCita.length === 0) {
          tratamientosCita = cita.tratamientos;
        }

      const fcActual = this.$moment();
      let horaInicio = cita.horaInicio.toString();
      if (horaInicio.length < 4) {horaInicio = "0" + horaInicio;}
      horaInicio =horaInicio.substr(0, 2) + ":" + horaInicio.substr(2, 3);
      const fechaCita = this.$moment(cita.fechaCitaSinZona + " " + horaInicio);
    
      if (fechaCita <= fcActual) {
        valido = false;
        this.msgValidacion += "<li>No se puede sobre agendar una cita con horario pasado</li>";
      }

      if (!valido) {

        this.msgValidacion += "</ul>";
        this.mostrarErrorVal = true;
        return;

      } else {
        this.datosPreCita = {
          idCita: cita.idCita,
          sillon: cita.sillon,
          idEspecialidad: cita.idEspecialidad,
          idEmpleado: cita.idDoctor,
          fechaCita: cita.fechaCita,
          horaInicio: {
            HH: cita.horaInicio.substring(0, 2),
            mm: cita.horaInicio.substring(2, 5)
          },

          citaReagendar: false,
          citaDesdeCal: false,
          citaEdicion: true,
          citaSobreAgendar: true,
        };
        this.modalNuevaCita = true;

      }

    },

    async sobreAgendable(cita) {
      this.loading = true;
      const parametros = {
        idCitaOriginal: cita.idCita,
        idMovimientoAgendable: 1
      }

      this.$http
          .post(
              this.$api +
              "sobreAgendable/guardarMarcaCitaSobreAgendable", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              console.log("response", response)
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
            this.buscarAgenda();
          });
    },
   async deshabilitarSobreAgendable(cita) {
     this.loading = true;
      const parametros = {
        idCitaOriginal: cita.idCita,
        idMovimientoAgendable: 7
      }

      this.$http
          .post(
              this.$api +
              "sobreAgendable/guardarMovimientosAgendable", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              console.log("response", response)
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
            this.buscarAgenda();
          });
    },


  },
}
</script>

<style>
  #modalNuevaCitaV2 .modal-header {
    height: 50px;
    border: none !important;
    color: #053672 !important;
    background-color: #fff !important;
  }
</style>

<style scoped>
.animacionBoton:hover {
  background-color: #ededed
}

.fade-in-bck {
  -webkit-animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

@keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
}

.selectWeek {
  color: #1b81af;
  font-weight: 600;
}

.fade-out-right {
  -webkit-animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}

@keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}

.fade-in-right {
  -webkit-animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-left {
  -webkit-animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.sticky-container {
  position: fixed;
  right: 0px;
  top: 50px;

  z-index: 1100;
}

.sticky li {
  border-radius: 20px 0px 0px 20px;
  box-shadow: -10px 11px 17px -6px rgba(0, 0, 0, 0.12);

  list-style-type: none;
  background-color: #fff;
  color: #efefef;
  height: 650px;
  padding: 10px;
  margin: 0px 0px 1px 0px;
}

.sticky li p {
  padding-top: 5px;
  margin: 0px;
  line-height: 16px;
  font-size: 11px;
}

.sticky li p a {
  text-decoration: none;
  color: #2c3539;
}

.sticky li p a:hover {
  text-decoration: underline;
}

.bCardAgenda {
  margin: 0.5%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}

.bCardAgenda-lateral {
  height: 100%;
  font-size: 11px;
  font-weight: bolder;
  text-align: left;
}

.boton-agenda-switch {
  border-radius: 50rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-right: 2px;
}

.boton-agenda {
  border-radius: 50rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
  padding: 5px;
}

.boton-agenda-inv, .boton-agenda-inv:hover {
  border-radius: 50rem;
  color:  var(--color-icono);
  background-color: white;
  border-color: #D0D0D0FF;
  box-shadow: 2px 3px 4px #c4c4c4;
  padding: 5px;
}

.boton-agenda-inv:hover, .boton-agenda-inv:active {
  border-color: var(--color-icono);
}

.icon-boton-agenda {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}

.icon-boton-agenda-1 {
  margin: auto;
  height: 20px;
  display: block;
  padding: 1px;
}

.icon-boton-agenda-11 {
  margin: auto;
  height: 10px;
  display: block;
  padding: 1px;
}

.icon-boton-agenda-2 {
  margin: auto;
  height: 10px;
  display: inline;
  padding: 1px;
}

.icon-boton-agenda-3 {
  margin: auto;
  height: 15px;
  display: inline;
  padding: 2px;
  background-color: #A2DAE3;
  filter: invert(44%) sepia(100%) saturate(372%) hue-rotate(140deg) brightness(98%) contrast(95%);
  border-radius: 2px;
}

.caja-barra-lateral {
  max-height: 500px;
  border: 1.5px solid #44a2dd;
  display: block;
  border-radius: 20px;
  padding: 8px;
}

.caja-barra-lateral-body {
  max-height: 480px;
  overflow:auto;
}

#filtros-title {
  background: none !important;
  border: none !important;
  color: var(--color-icono)  !important;
}

#filtros-title svg path {
  fill: blue!important;
}

.filtros, .filtros:hover {
  background: none;
  border: none;
  color: var(--color-icono);
  font-size: 10px;
  font-weight: bolder;
}

.filtros:hover {
  border-bottom: solid 2px var(--color-icono);
}

.filtro-normal {
  color:black;
  font-weight: normal;
}

.filtro-normal em {
  filter: invert(0%) sepia(45%) saturate(27%) hue-rotate(36deg) brightness(89%) contrast(105%);
}

#popover-calendario {
  background: none;
  border: none;
  color:  var(--color-icono);
  font-weight: bolder;
}

.fecha-dia-actual {
  color: var(--color-dia-actual) !important;
  /*text-shadow: 1px 1px 2px #515151, 0 0 1em #ccc, 0 0 0.2em #7c7c91;*/
}

.boton-agenda-switch {
  background: none !important;
  border: none !important;
  padding: 3px !important;
  color: white;
  font-size: 10px;
  font-weight: bolder;
}

.boton-agenda-switch-active {
  background-color: var(--color-icono) !important;
  border-color: var(--color-icono) !important;
  border-radius: 50px !important;
  width: 100px !important;
  padding: 3px !important;
  color: white;
  font-size: 10px;
  font-weight: bolder;
}


.centrar {
  display: flex;
  justify-content: center;
}

.dropbtn {
  background-color: #3498db;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropup {
  position: relative;
  display: inline-block;
}

.dropup-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  bottom: 50px;
  z-index: 1;
}

.dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-content a:hover {
  background-color: #ccc;
}

.dropup:hover .dropup-content {
  display: block;
}

.dropup:hover .dropbtn {
  background-color: #2980b9;
}

.textoSubtitulo {
  color: #626262;
  font-weight: 600;
  font-size: 18px;
  text-align: left;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.iconoFondoColor {
  color: #0fa3b9 !important;
  /*background-color: #9fd9e2;*/
  padding: 1px;
  border-radius: 5px;
}

.scroll-container {
  height: 400px;
  overflow-y: scroll;
}

.scroll-container::-webkit-scrollbar {
  width: 5px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background-color: #b7b7b7;
}

.scroll-container::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 50%;
}

.word-break {
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
}

.modal-content {
  position: fixed;
 /* display: -ms-flexbox;*/
  display: fixed;
  width: 75% !important;
  left: 14% !important;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;

  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

</style>
